export const detailjson = function(obj,type) {
    
    var data='',list=[];
    if(obj=='vehicle')
    {
       list=[
       		{
       			"truckid": "556",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307142",
       			"username": "177****2689",
       			"licenseplatenumber": "湘K00068D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002713",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/89253f1e05f1e5816b83f1756a2929da.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/fcd9abf1c06b01330ca308ba68fde8d2.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211291",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/3e6513706a411d361e441dd93f5a3acd.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KB976挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a5f52e16094ccd0d96f1f12486137a02.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724832007",
       			"dateline": "1714033732",
       			"modifytime": "1725708011",
       			"operateuid": "307142",
       			"operateuname": "17775702689",
       			"thingid": "843",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K00068D",
       			"thingregnum": "00068",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674915",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002713",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.971019,
       			"maplng": 111.908021,
       			"mapaddr": null,
       			"staffname": "周解斌",
       			"staffmobile": "17775702689",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902658",
       			"vehiclelat": "27.974544",
       			"vehicleheight": "264",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "299",
       			"vehiclemileage": "33477.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225453",
       			"todaymileage": "510.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "343",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299370",
       			"username": "龚奇峰",
       			"licenseplatenumber": "湘K00338D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W4N3002788",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/cc8f37234e000cb24ef0e8546b800d2d.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209654",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/7a871925fbf7015c0b083f8e73ca02e6.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KV509挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747656",
       			"dateline": "1678693585",
       			"modifytime": "1725704273",
       			"operateuid": "299370",
       			"operateuname": "198****7222",
       			"thingid": "343",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K00338D",
       			"thingregnum": "00338",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846237044",
       			"outcardno": "0000003496038298",
       			"thingvin": "LFCAH96W4N3002788",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775441,
       			"maplng": 111.696641,
       			"mapaddr": null,
       			"staffname": "龚奇峰",
       			"staffmobile": "19873827222",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691146",
       			"vehiclelat": "27.778810",
       			"vehicleheight": "170",
       			"vehiclespeed": "5.00",
       			"vehicledirection": "339",
       			"vehiclemileage": "97627.6",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225453",
       			"todaymileage": "338.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "344",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299368",
       			"username": "180****2772",
       			"licenseplatenumber": "湘K00608D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003582",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e82d4035052a847b7c27275c3a87e8f5.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209718",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/9d1a19f0267b31846a1f310fcf98c23a.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KD826挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/48ea7e06c4fb3543f10e292a72df8096.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747656",
       			"dateline": "1678693585",
       			"modifytime": "1725691263",
       			"operateuid": "299368",
       			"operateuname": "180****2772",
       			"thingid": "344",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K00608D",
       			"thingregnum": "00608",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846210336",
       			"outcardno": "0000002152393625",
       			"thingvin": "LFCAH96W0N3003582",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775702,
       			"maplng": 111.697137,
       			"mapaddr": null,
       			"staffname": "周雄",
       			"staffmobile": "18073862772",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691641",
       			"vehiclelat": "27.779070",
       			"vehicleheight": "187",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "182142.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224914",
       			"todaymileage": "309.3",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "641",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306054",
       			"username": "19908422633",
       			"licenseplatenumber": "湘K01279D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002185",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a3a0276ade8cc41b271e18fe670b529e.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/aa705497994887d787c9017af069f159.jpg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211091",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/80c8de83276060a1bac63f97ac5a3be7.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/94b1f6c36ecff4f5c1cca252b7ffbd5e.jpg",
       			"transportvalidenddate": "2027-04-08",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "11.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KL667挂",
       			"trailertypecode": "B3E",
       			"trailerloadweight": "40000",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c99a4e5309aded8c87fa5920667c34fb.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838081",
       			"dateline": "1713764524",
       			"modifytime": "1725670226",
       			"operateuid": "306054",
       			"operateuname": "19908422633",
       			"thingid": "740",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01279D",
       			"thingregnum": "01279",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906971",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002185",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776188,
       			"maplng": 111.696177,
       			"mapaddr": null,
       			"staffname": "周玉红",
       			"staffmobile": "19908422633",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690683",
       			"vehiclelat": "27.779558",
       			"vehicleheight": "180",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "107",
       			"vehiclemileage": "46116.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225458",
       			"todaymileage": "346.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "717",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306883",
       			"username": "186****6399",
       			"licenseplatenumber": "湘K01306D",
       			"truckowner": "涟源瑞麟智慧物流有货公司",
       			"identifycode": "LFXAH76W5R3002565",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/145800698382c9a690d9bb550e5a5a37.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/df9b38ce4a0422e16fa6d7c4bba4e981.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "2024-05-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211476",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/61ddff5e4e9209cbc1b5933c66ff1329.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/e69431367814da8d7f9185da7e492299.jpg",
       			"transportvalidenddate": "2027-05-26",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF016挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有货公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/bf73f42a307d1c7c3d2aeeba52bd2aec.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838968",
       			"dateline": "1716969528",
       			"modifytime": "1725718625",
       			"operateuid": "306883",
       			"operateuname": "186****6399",
       			"thingid": "885",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有货公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01306D",
       			"thingregnum": "01306",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906987",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002565",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910498,
       			"maplng": 111.857525,
       			"mapaddr": null,
       			"staffname": "曾再生",
       			"staffmobile": "18673856399",
       			"taskid": "0",
       			"tasknum": "225",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.852108",
       			"vehiclelat": "27.913966",
       			"vehicleheight": "182",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "26191.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225452",
       			"todaymileage": "604.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "575",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307074",
       			"username": "183****2168",
       			"licenseplatenumber": "湘K01516D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002683",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/af6e71b089ccea663991c045b2a44a94.jpg",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "2039-04-18",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察大队",
       			"roadtransportnumber": "431382211235",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/3475540d8bf214b8f67c68e02d189eb2.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-05",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF139挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/f9c5880738b445bbc10764a747129bf3.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724839016",
       			"dateline": "1713764524",
       			"modifytime": "1725612205",
       			"operateuid": "307074",
       			"operateuname": "183****2168",
       			"thingid": "780",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01516D",
       			"thingregnum": "01516",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674931",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002683",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765672,
       			"maplng": 111.980855,
       			"mapaddr": null,
       			"staffname": "梁伟文",
       			"staffmobile": "18373802168",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975391",
       			"vehiclelat": "27.769050",
       			"vehicleheight": "123",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "26309.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225355",
       			"todaymileage": "0.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "345",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305691",
       			"username": "19373871777",
       			"licenseplatenumber": "湘K01626D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3003493",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/2a934007ee0033384bcbafe98d019c0a.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209721",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/d376430b7058c2d1276a7e14665dc0a5.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KK313挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725706889",
       			"operateuid": "305691",
       			"operateuname": "19373871777",
       			"thingid": "345",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01626D",
       			"thingregnum": "01626",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64821210109",
       			"outcardno": "00000010853449",
       			"thingvin": "LFCAH96W1N3003493",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765802,
       			"maplng": 111.980779,
       			"mapaddr": null,
       			"staffname": "19373871777",
       			"staffmobile": "19373871777",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975316",
       			"vehiclelat": "27.769180",
       			"vehicleheight": "147",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "164005.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225248",
       			"todaymileage": "331.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "346",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "301391",
       			"username": "淡淡的微笑",
       			"licenseplatenumber": "湘K01758D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W5N3003562",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/3bbada48e6cb63da5601ae29551baf6a.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9c459edd2b92d7c729d76cab74350c9f.jpg",
       			"licenseexpiredate": "2037-12-22",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209666",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/254e839e4cae78ad630e2bd3c59a23a3.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/50132c87ea70ce14b8dff96dfa4c06e5.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KH185挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724815729",
       			"dateline": "1678693585",
       			"modifytime": "1725708846",
       			"operateuid": "301391",
       			"operateuname": "淡淡的微笑",
       			"thingid": "346",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01758D",
       			"thingregnum": "01758",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846237171",
       			"outcardno": "",
       			"thingvin": "LFCAH96W5N3003562",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.04891,
       			"maplng": 112.969893,
       			"mapaddr": null,
       			"staffname": "吴孟均",
       			"staffmobile": "17573885598",
       			"taskid": "0",
       			"tasknum": "225",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.964388",
       			"vehiclelat": "28.052350",
       			"vehicleheight": "25",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "184460.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224921",
       			"todaymileage": "460.8",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "347",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300276",
       			"username": "180****1916",
       			"licenseplatenumber": "湘K01796D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W4N3003553",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/f3afc31ee366ca238651d05905bb53b3.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/24c26d1820ca376e1fb5290b9d85dadb.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209646",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/2b31bd68b7d750c7a06b20ba8e1c46e2.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KU039挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9cdf8f091a8be3b8c74e17505e433e19.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724814499",
       			"dateline": "1678693585",
       			"modifytime": "1725694480",
       			"operateuid": "300276",
       			"operateuname": "180****1916",
       			"thingid": "347",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01796D",
       			"thingregnum": "01796",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846807419",
       			"outcardno": "",
       			"thingvin": "LFCAH96W4N3003553",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049152,
       			"maplng": 112.970675,
       			"mapaddr": null,
       			"staffname": "张新铭",
       			"staffmobile": "18033081916",
       			"taskid": "0",
       			"tasknum": "222",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965168",
       			"vehiclelat": "28.052590",
       			"vehicleheight": "67",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "157408.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225456",
       			"todaymileage": "336.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "439",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307083",
       			"username": "易建成",
       			"licenseplatenumber": "湘K01889D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003551",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a7d801cf1e174b668f6dc0370e9237a5.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209722",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/a0ba7319c9ca34f84b4803cc81a5422c.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘K9083挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725699149",
       			"operateuid": "307083",
       			"operateuname": "134****9173",
       			"thingid": "348",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K01889D",
       			"thingregnum": "01889",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846214914",
       			"outcardno": "",
       			"thingvin": "LFCAH96W0N3003551",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.721948,
       			"maplng": 111.960988,
       			"mapaddr": null,
       			"staffname": "易建成",
       			"staffmobile": "13467889173",
       			"taskid": "0",
       			"tasknum": "225",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.955581",
       			"vehiclelat": "27.725370",
       			"vehicleheight": "137",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "141053.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225306",
       			"todaymileage": "239.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "716",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307114",
       			"username": "17680386617",
       			"licenseplatenumber": "湘K02309D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002666",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/80addd9b29283a46afe511ef51b23129.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/934502ed40710f8b593803872276b850.jpg",
       			"licenseexpiredate": "39-05-22",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交警察支队",
       			"roadtransportnumber": "431382211507",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/fd4e29946f0c9c53956dbd0d0fd84e3c.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/aa0944e87cf984644c00ff15f3af0564.jpg",
       			"transportvalidenddate": "",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "2345",
       			"outlinewidth": "3150",
       			"outlineheight": "7115",
       			"trailerplatenumber": "湘KE965挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "莲源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6d5a7c51e5491daa38ba71ef26874448.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"validEndDate\",\"remarks\":\"运输证有效期有误\",\"result\":1}]",
       			"audittime": "1725520811",
       			"dateline": "1716969560",
       			"modifytime": "1725695376",
       			"operateuid": "307114",
       			"operateuname": "17680386617",
       			"thingid": "886",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02309D",
       			"thingregnum": "02309",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906984",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002666",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910034,
       			"maplng": 111.857686,
       			"mapaddr": null,
       			"staffname": "邱小兵",
       			"staffmobile": "17680386617",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.852269",
       			"vehiclelat": "27.913502",
       			"vehicleheight": "175",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "23910.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225051",
       			"todaymileage": "470.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "559",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306534",
       			"username": "181****1141",
       			"licenseplatenumber": "湘K02316D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002709",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/c2fa39aa50b67f36ce1f2662827a8e21.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/f2eeca50515803003679e8ac4d9d1ecd.jpg",
       			"licenseexpiredate": "2039-04-22",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211285",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/9e14f978205a53f7d1852e8694b850c0.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/0ff048aa3eb09f9acff4120ed64da1be.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-22",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KC666挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/110ba0be4039835f0b6cc8949c801e5c.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725586006",
       			"operateuid": "306534",
       			"operateuname": "18142681141",
       			"thingid": "844",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02316D",
       			"thingregnum": "02316",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674912",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002709",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766324,
       			"maplng": 111.9809,
       			"mapaddr": null,
       			"staffname": "181****1141",
       			"staffmobile": "18142681141",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975436",
       			"vehiclelat": "27.769702",
       			"vehicleheight": "127",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "32505.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225332",
       			"todaymileage": "167.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "349",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299719",
       			"username": "189****3459",
       			"licenseplatenumber": "湘K02318D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W7N3003577",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ec64c62ce62aae962199cb23c9a79c2a.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/4bdf831515c84800c76e13ce57079452.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209630",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/aa2e35e98cffaaa37188d555767577aa.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KY528挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/cc377eba9fafdc42ae2864672588b021.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "3",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"drivingLicenseMainFilename\",\"remarks\":\"行驶证正面照片有误\",\"result\":1},{\"checked\":true,\"custom\":true,\"remarks\":\"请上传行驶证带质量副页\"}]",
       			"audittime": "1724761160",
       			"dateline": "1678693585",
       			"modifytime": "1725705578",
       			"operateuid": "299719",
       			"operateuname": "189****3459",
       			"thingid": "349",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02318D",
       			"thingregnum": "02318",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848676775",
       			"outcardno": "0000000808422809",
       			"thingvin": "LFCAH96W7N3003577",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048408,
       			"maplng": 112.971058,
       			"mapaddr": null,
       			"staffname": "李开颜",
       			"staffmobile": "18932433459",
       			"taskid": "0",
       			"tasknum": "229",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965550",
       			"vehiclelat": "28.051845",
       			"vehicleheight": "55",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "161670.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225341",
       			"todaymileage": "343.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "560",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307151",
       			"username": "151****8516",
       			"licenseplatenumber": "湘K02662D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002606",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/116c66b516dd6e671be0673461b91179.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/e65b8d0c1785d39a75b2b6c9bbbabe5e.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211282",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/95c71d372963ba58977db5fce7091a98.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KL802挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/bb6e8f79dca94bc1cebaf2dd28b17b0b.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725694904",
       			"operateuid": "307151",
       			"operateuname": "151****8516",
       			"thingid": "845",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02662D",
       			"thingregnum": "02662",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674944",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002606",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.15143,
       			"maplng": 112.750052,
       			"mapaddr": null,
       			"staffname": "151****8516",
       			"staffmobile": "15107388516",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "112.744494",
       			"vehiclelat": "28.154783",
       			"vehicleheight": "99",
       			"vehiclespeed": "73.00",
       			"vehicledirection": "70",
       			"vehiclemileage": "35017.0",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "526.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "656",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307274",
       			"username": "19186969388",
       			"licenseplatenumber": "湘K02698D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002176",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/3e0c6673b93c18bb4b489182b61682e9.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/28/7425e32c8f289d4dd6db2d6ec378581f.jpg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211148",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/21145fccd073d80bcc88d810ba35508d.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/28/abce833eb2963fde69fa8e7edc96b95d.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-19",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KZ123挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源市瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/87beb3fb79a2aa0be94bf95f83d8bc0d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724903627",
       			"dateline": "1713764524",
       			"modifytime": "1725676419",
       			"operateuid": "307274",
       			"operateuname": "19186969388",
       			"thingid": "741",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02698D",
       			"thingregnum": "02698",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356963",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002176",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766398,
       			"maplng": 111.981158,
       			"mapaddr": null,
       			"staffname": "19186969388",
       			"staffmobile": "19186969388",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975694",
       			"vehiclelat": "27.769775",
       			"vehicleheight": "128",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "41028.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225233",
       			"todaymileage": "331.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "651",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307232",
       			"username": "刘义芬",
       			"licenseplatenumber": "湘K02706D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002218",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/392241ad58f35e54abf0ad86dff53382.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/26f7790dba81f2614a6cc88d3315182b.jpg",
       			"licenseexpiredate": "2027-01-09",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211132",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6c63f225d8c898ecf8e96d5e83e4bed3.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KP161挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/ca2ed12b5a29557691f9c698773e44c8.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724837338",
       			"dateline": "1713764524",
       			"modifytime": "1725705217",
       			"operateuid": "307232",
       			"operateuname": "18692902334",
       			"thingid": "761",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02706D",
       			"thingregnum": "02706",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357340",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002218",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765792,
       			"maplng": 111.981072,
       			"mapaddr": null,
       			"staffname": "刘义芬",
       			"staffmobile": "18692902334",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975608",
       			"vehiclelat": "27.769169",
       			"vehicleheight": "137",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "177",
       			"vehiclemileage": "39235.6",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225504",
       			"todaymileage": "348.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "561",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307126",
       			"username": "181****5496",
       			"licenseplatenumber": "湘K02716D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002576",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174060947906.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174060981993.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211315",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169639518148.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KB782挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/36e305c456be96a57b01ca27a86d8d45.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725630273",
       			"operateuid": "307126",
       			"operateuname": "181****5496",
       			"thingid": "846",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02716D",
       			"thingregnum": "02716",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674937",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002576",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.194056,
       			"maplng": 112.425209,
       			"mapaddr": null,
       			"staffname": "181****5496",
       			"staffmobile": "18173795496",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.419491",
       			"vehiclelat": "28.197236",
       			"vehicleheight": "91",
       			"vehiclespeed": "55.00",
       			"vehicledirection": "81",
       			"vehiclemileage": "28555.8",
       			"vehiclewarn": "278528",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225502",
       			"todaymileage": "484.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "650",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306061",
       			"username": "18673488477",
       			"licenseplatenumber": "湘K02726D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002170",
       			"licensemainimage": "tgjffwl/khy/2024/08/27/a4e5fc965cfff4ed3e8b19cd4802a9c2.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/27/efd3f5b88297a9b8e16a625ff013b501.jpg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211136",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/27/37dcfbabb464594580f5a68e05d2344e.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/27/02c1f1d764294cec2d642650e0345863.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KS976挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/fdf4587ffbe01a66e76b7db5f51eb466.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724831259",
       			"dateline": "1713764524",
       			"modifytime": "1725714529",
       			"operateuid": "306061",
       			"operateuname": "18673488477",
       			"thingid": "762",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02726D",
       			"thingregnum": "02726",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356959",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002170",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970841,
       			"maplng": 111.908185,
       			"mapaddr": null,
       			"staffname": "龙立林",
       			"staffmobile": "18673488477",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902822",
       			"vehiclelat": "27.974366",
       			"vehicleheight": "265",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "45973.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225437",
       			"todaymileage": "504.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "562",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307173",
       			"username": "193****0777",
       			"licenseplatenumber": "湘K02736D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002566",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ad9e79be74acd6c84b17e4ddc8b293e2.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9e91f958ea8b03da1f65fadefd2dede1.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211278",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/12df9ab6e59fdc7f9ce0953b98a406ff.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-07",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KE872挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/87377861d46a1d2e9b37d85a5c255ec2.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838980",
       			"dateline": "1713764524",
       			"modifytime": "1725713244",
       			"operateuid": "307173",
       			"operateuname": "19373870777",
       			"thingid": "781",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K02736D",
       			"thingregnum": "02736",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674946",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002566",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.717251,
       			"maplng": 112.415726,
       			"mapaddr": null,
       			"staffname": "李大云",
       			"staffmobile": "19373870777",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.410041",
       			"vehiclelat": "27.720361",
       			"vehicleheight": "92",
       			"vehiclespeed": "67.00",
       			"vehicledirection": "307",
       			"vehiclemileage": "28572.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225504",
       			"todaymileage": "462.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "686",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307117",
       			"username": "邱吉彪",
       			"licenseplatenumber": "湘K03055D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002678",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/8e2e05dbeeac00e761e892b9b1577bff.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/05f2213b8c3c2f4970cbcb762147b77b.jpeg",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-24",
       			"licenseregisterdate": "2024-04-24",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211314",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/e3138502dd0c85d36d67299f07b80ae8.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K5056挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838271",
       			"dateline": "1714033732",
       			"modifytime": "1725680932",
       			"operateuid": "307117",
       			"operateuname": "137****2599",
       			"thingid": "857",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03055D",
       			"thingregnum": "03055",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906991",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002678",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766363,
       			"maplng": 111.980844,
       			"mapaddr": null,
       			"staffname": "邱吉彪",
       			"staffmobile": "13762812599",
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975380",
       			"vehiclelat": "27.769741",
       			"vehicleheight": "131",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "27136.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225028",
       			"todaymileage": "337.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "563",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307076",
       			"username": "159****1799",
       			"licenseplatenumber": "湘K03259D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002578",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/8a89214b31fb66f4c0422132b333b297.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/fefe58c02329aaa3fd741f5d7e9dbf88.jpg",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211309",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/2bb5c99b9f1371adb31c14873b634da7.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/4bf1bf436a4b6b9568f3c6d986e6c161.jpg",
       			"transportvalidenddate": "2027-04-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-18",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KP795挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/d8982e06f457bb9a428f9999d367ed19.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"roadTransportPermitNumber\",\"remarks\":\"道路运输经营许可证号有误\",\"result\":1}]",
       			"audittime": "1724832245",
       			"dateline": "1722321865",
       			"modifytime": "1725611940",
       			"operateuid": "307076",
       			"operateuname": "15973881799",
       			"thingid": "945",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03259D",
       			"thingregnum": "03259",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674910",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002578",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765699,
       			"maplng": 111.980771,
       			"mapaddr": null,
       			"staffname": "蔡立才",
       			"staffmobile": "15973881799",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975308",
       			"vehiclelat": "27.769077",
       			"vehicleheight": "130",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "19781.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225132",
       			"todaymileage": "0.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "640",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307252",
       			"username": "193****1888",
       			"licenseplatenumber": "湘K03336D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002213",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/845c02814b506b13302742f26b973da4.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b687577502ce91d8e762f879ea936f8d.jpg",
       			"licenseexpiredate": "2025-04-01",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211141",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/454673d65ed1a768e6588904990ca10c.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/64d3f4d72ba95c87ad66c6fe4d268d2e.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K7615挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9c5235624b3578597e2dce7940bb9c2e.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838184",
       			"dateline": "1713764524",
       			"modifytime": "1725672730",
       			"operateuid": "307252",
       			"operateuname": "淡淡的微笑",
       			"thingid": "742",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03336D",
       			"thingregnum": "03336",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356967",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002213",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776285,
       			"maplng": 111.69618,
       			"mapaddr": null,
       			"staffname": "杨宇",
       			"staffmobile": "19386941888",
       			"taskid": "0",
       			"tasknum": "212",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690686",
       			"vehiclelat": "27.779655",
       			"vehicleheight": "177",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "113",
       			"vehiclemileage": "42831.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225459",
       			"todaymileage": "353.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "351",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305693",
       			"username": "甘鹏程",
       			"licenseplatenumber": "湘K03356D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W5N3003559",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4eb20023ebb9e6b1bdc5cb38a8c4075b.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209663",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/ab6094d7c642a584ec4ec299b5778406.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KH303挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725703093",
       			"operateuid": "305693",
       			"operateuname": "152****2929",
       			"thingid": "351",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03356D",
       			"thingregnum": "03356",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846233642",
       			"outcardno": "000000296599644",
       			"thingvin": "LFCAH96W5N3003559",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048948,
       			"maplng": 112.969876,
       			"mapaddr": null,
       			"staffname": "甘鹏程",
       			"staffmobile": "15273312929",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.964371",
       			"vehiclelat": "28.052388",
       			"vehicleheight": "53",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "149862.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "341.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "734",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307513",
       			"username": null,
       			"licenseplatenumber": "湘K03526D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002693",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4883dc61599525fc952760457f156f5c.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/8aabe598cec73d3e763cdae3523250e4.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-05-23",
       			"licenseregisterdate": "2024-05-23",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211522",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/96d96433cd08187cef7c8c732d12932c.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/79d22c378f723635dcf385740d05b6f7.jpeg",
       			"transportvalidenddate": "2027-06-03",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-23",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KN116挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/02516124af19288a1c04e2228c49bb75.jpeg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "0",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724917978",
       			"dateline": "1716969767",
       			"modifytime": "1725694571",
       			"operateuid": "307513",
       			"operateuname": "138****9675",
       			"thingid": "894",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03526D",
       			"thingregnum": "03526",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906980",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002693",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766291,
       			"maplng": 111.980833,
       			"mapaddr": null,
       			"staffname": "谢熙东",
       			"staffmobile": "13873819675",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975369",
       			"vehiclelat": "27.769669",
       			"vehicleheight": "141",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "116",
       			"vehiclemileage": "9250.1",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "308.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "352",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "301706",
       			"username": "166****1599",
       			"licenseplatenumber": "湘K03609D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3003494",
       			"licensemainimage": "tgjffwl/image/2023/05/khy/0f2e7526-3854-48fd-8031-28e183898a11.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209673",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2023/05/khy/a688ded7-6e0b-43ac-9df1-0f30b447702a.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KU993挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0ebfb7bb0ed104c3a108cae0aa5ff646.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724807360",
       			"dateline": "1721961742",
       			"modifytime": "1725712395",
       			"operateuid": "301706",
       			"operateuname": "166****1599",
       			"thingid": "937",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K03609D",
       			"thingregnum": "03609",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64821218125",
       			"outcardno": "",
       			"thingvin": "LFCAH96W3N3003494",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049546,
       			"maplng": 112.969309,
       			"mapaddr": null,
       			"staffname": "龙韶峰",
       			"staffmobile": "16673891599",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.963806",
       			"vehiclelat": "28.052988",
       			"vehicleheight": "37",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "168204.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225038",
       			"todaymileage": "448.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "353",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "301764",
       			"username": "18173829858",
       			"licenseplatenumber": "湘K05007D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3002836",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/264e4fda8106a966e37d57ad7685dc47.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-27",
       			"licenseregisterdate": "2022-12-27",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209665",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/a4de8d9fb6495926cd3d1228f8b7e0a2.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-27",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KA583挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a7063d491def6c4f0532ff351916dffd.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725710606",
       			"operateuid": "301764",
       			"operateuname": "18173829858",
       			"thingid": "353",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05007D",
       			"thingregnum": "05007",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846251967",
       			"outcardno": "0000002688092058",
       			"thingvin": "LFCAH96W0N3002836",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775284,
       			"maplng": 111.694893,
       			"mapaddr": null,
       			"staffname": "18173829858",
       			"staffmobile": "18173829858",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.689401",
       			"vehiclelat": "27.778656",
       			"vehicleheight": "201",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "13218.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225225",
       			"todaymileage": "408.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "639",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306659",
       			"username": "133****4999",
       			"licenseplatenumber": "湘K05026D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002172",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a25a728ca83b6294a985a0539c47f963.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/49c2ccaee53dc87f90dc26d117dd93e7.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211138",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/ad6465ef455595480f4d2bf5fc4bc030.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/8c413fa31be4eda4f5059ea3295349c9.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K5016挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/f14b2e1b1203e8d5583f958116dde0fd.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724837484",
       			"dateline": "1713764524",
       			"modifytime": "1725674367",
       			"operateuid": "306659",
       			"operateuname": "13387434999",
       			"thingid": "743",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05026D",
       			"thingregnum": "05026",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356970",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002172",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776024,
       			"maplng": 111.696135,
       			"mapaddr": null,
       			"staffname": "杨攀",
       			"staffmobile": "13387434999",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690641",
       			"vehiclelat": "27.779394",
       			"vehicleheight": "184",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "105",
       			"vehiclemileage": "33751.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "352.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "564",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307060",
       			"username": "173****3587",
       			"licenseplatenumber": "湘K05065D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002582",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b58dfccbef8a2202bab81473a3233dd4.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b4e5dd8ec12872dfb2b46a6d89be72d5.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211293",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/1a14ad80a5bfa30167a7ccbb4442d606.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/3e85bb6480594032e4c113540f302a36.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KS636挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/ee6a3a1bf9211698da71d94b56ae66c5.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "3",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1714033732",
       			"modifytime": "1725697907",
       			"operateuid": "307060",
       			"operateuname": "173****3587",
       			"thingid": "847",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05065D",
       			"thingregnum": "05065",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674941",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002582",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.212534,
       			"maplng": 112.463541,
       			"mapaddr": null,
       			"staffname": "173****3587",
       			"staffmobile": "17363863587",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.457891",
       			"vehiclelat": "28.215775",
       			"vehicleheight": "84",
       			"vehiclespeed": "56.00",
       			"vehicledirection": "267",
       			"vehiclemileage": "16264.6",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225457",
       			"todaymileage": "411.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "565",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307282",
       			"username": "182****2305",
       			"licenseplatenumber": "湘K05195D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002351",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/baa48d3846fdcba2e1e13fa8aa6e6c50.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211276",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/402663023513c7b04414c66c84e9c6ed.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K5502挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6c61b90be20a0977e230a8f076e589ae.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724830247",
       			"dateline": "1713764524",
       			"modifytime": "1725628554",
       			"operateuid": "307282",
       			"operateuname": "182****2305",
       			"thingid": "782",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05195D",
       			"thingregnum": "05195",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674938",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002351",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.116812,
       			"maplng": 112.782633,
       			"mapaddr": null,
       			"staffname": "何帅",
       			"staffmobile": "18273782305",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.777083",
       			"vehiclelat": "28.120175",
       			"vehicleheight": "71",
       			"vehiclespeed": "38.00",
       			"vehicledirection": "121",
       			"vehiclemileage": "12591.4",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225503",
       			"todaymileage": "525.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "354",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300687",
       			"username": "15115985975",
       			"licenseplatenumber": "湘K05236D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96WXN3003556",
       			"licensemainimage": "tgjffwl/image/2023/05/khy/1085cbf7-604f-4a58-b03d-e06180bdb93c.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209671",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2023/05/khy/5fb041a3-bfb1-4564-a0a2-de61bceebed7.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KA726挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9318a5c9727cc420649648ee1dcedf6c.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747572",
       			"dateline": "1721687121",
       			"modifytime": "1725712543",
       			"operateuid": "300687",
       			"operateuname": "15115985975",
       			"thingid": "921",
       			"thingname": "电卡",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05236D",
       			"thingregnum": "05236",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846803843",
       			"outcardno": "",
       			"thingvin": "LFCAH96WXN3003556",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765932,
       			"maplng": 111.98087,
       			"mapaddr": null,
       			"staffname": "15115985975",
       			"staffmobile": "15115985975",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "111.975406",
       			"vehiclelat": "27.769310",
       			"vehicleheight": "158",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "156928.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225356",
       			"todaymileage": "319.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "566",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307141",
       			"username": "159****7886",
       			"licenseplatenumber": "湘K05568D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002687",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/9eb6ef442ae1a8f00f533e5e02239c0c.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/78d6dc3dba9691dbf4e041efa6a5fb4a.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211253",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/0538582e4450a3b638856eb34310087c.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KJ136挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6ee9ddd01c6bfa5ecaffdd1e7836cc9a.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724749197",
       			"dateline": "1714033732",
       			"modifytime": "1725687617",
       			"operateuid": "307141",
       			"operateuname": "159****7886",
       			"thingid": "835",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05568D",
       			"thingregnum": "05568",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674928",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002687",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.76568,
       			"maplng": 111.980757,
       			"mapaddr": null,
       			"staffname": "陈志",
       			"staffmobile": "15973087886",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "111.975294",
       			"vehiclelat": "27.769058",
       			"vehicleheight": "139",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "34518.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225010",
       			"todaymileage": "332.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "567",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307398",
       			"username": "15111151550",
       			"licenseplatenumber": "湘K05605D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002587",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/d5b2f46f6638398c8909bae848efd8e0.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/cb05e931066420cbf7763d6591359295.jpeg",
       			"licenseexpiredate": "2039-05-21",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211298",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/757a280c4b31acb9310dfcd204b21017.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/11970321f725ac0c16d055baf8171973.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K8132挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/2e1152ce60c3c794aea54e39d783e83d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747572",
       			"dateline": "1721968525",
       			"modifytime": "1725669391",
       			"operateuid": "307398",
       			"operateuname": "151****1550",
       			"thingid": "939",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05605D",
       			"thingregnum": "05605",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674927",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002587",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970791,
       			"maplng": 111.908113,
       			"mapaddr": null,
       			"staffname": "15111151550",
       			"staffmobile": "15111151550",
       			"taskid": "22087",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "货运司机已接单",
       			"vehiclelng": "111.902750",
       			"vehiclelat": "27.974316",
       			"vehicleheight": "260",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "76",
       			"vehiclemileage": "24510.3",
       			"vehiclewarn": "278528",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225457",
       			"todaymileage": "253.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "568",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307309",
       			"username": "18373780789",
       			"licenseplatenumber": "湘K05685D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002569",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e16cac1fc80c56ff25a5be57b855a1cd.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/acabea70af5c18c934aa3c813491360a.jpeg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211242",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/dbf399f1afe459a3cb64fdadfa6053f5.jpeg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF289挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6c80a33cf84932a8df33d21561fb1ba4.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1725001638",
       			"dateline": "1713764524",
       			"modifytime": "1725698928",
       			"operateuid": "307309",
       			"operateuname": "18373780789",
       			"thingid": "771",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05685D",
       			"thingregnum": "05685",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674904",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002569",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.083042,
       			"maplng": 112.821385,
       			"mapaddr": null,
       			"staffname": "文鹏程",
       			"staffmobile": "18373780789",
       			"taskid": "22087",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "15",
       			"applystatus": "0",
       			"operatemsg": "货运司机已接单",
       			"vehiclelng": "112.815891",
       			"vehiclelat": "28.086458",
       			"vehicleheight": "93",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "289",
       			"vehiclemileage": "27021.7",
       			"vehiclewarn": "262148",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225501",
       			"todaymileage": "548.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "629",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307073",
       			"username": "15273898263",
       			"licenseplatenumber": "湘K05716D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002721",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/bf99bf8b1fbad5109f6410c7da048af0.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/bf99bf8b1fbad5109f6410c7da048af0.jpg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382204891",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/2fe73bd5c3f3c4c9d2de3deb49d8807b.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/2fe73bd5c3f3c4c9d2de3deb49d8807b.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF588挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/726f1bc78ec52083ffd1f34e1258db33.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725694062",
       			"operateuid": "307073",
       			"operateuname": "15273898263",
       			"thingid": "859",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05716D",
       			"thingregnum": "05716",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674901",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002721",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.76591,
       			"maplng": 111.980813,
       			"mapaddr": null,
       			"staffname": "15273898263",
       			"staffmobile": "15273898263",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "111.975350",
       			"vehiclelat": "27.769288",
       			"vehicleheight": "125",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "23752.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225147",
       			"todaymileage": "270.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "357",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305694",
       			"username": "15773870979",
       			"licenseplatenumber": "湘K05768D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W4N3003519",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/7b16d1390166b847c259c80709b0a881.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/412e94e78b614e3c2727d013fba103b1.jpg",
       			"licenseexpiredate": "2037-12-21",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209717",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/a7452f9d7edbbbaec4693b334a86afe1.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "93",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘K05768D",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/1da510fe904aa56f3734061eac4633ad.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725703199",
       			"operateuid": "305694",
       			"operateuname": "15773870979",
       			"thingid": "357",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05768D",
       			"thingregnum": "05768",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846238344",
       			"outcardno": "0000002689554074",
       			"thingvin": "LFCAH96W4N3003519",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.901365,
       			"maplng": 111.864561,
       			"mapaddr": null,
       			"staffname": "李亮",
       			"staffmobile": "15773870979",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.859158",
       			"vehiclelat": "27.904843",
       			"vehicleheight": "170",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "149946.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224643",
       			"todaymileage": "276.1",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "569",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307078",
       			"username": "177****7136",
       			"licenseplatenumber": "湘K05776D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002681",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174061901901.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174061942049.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211284",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169642873295.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KT869挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9323b5183d3aabdcd9733636a35d6daa.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725586577",
       			"operateuid": "307078",
       			"operateuname": "17763617136",
       			"thingid": "848",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05776D",
       			"thingregnum": "05776",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674942",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002681",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.98165,
       			"maplng": 112.096089,
       			"mapaddr": null,
       			"staffname": "177****7136",
       			"staffmobile": "17763617136",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.090341",
       			"vehiclelat": "27.984805",
       			"vehicleheight": "136",
       			"vehiclespeed": "68.00",
       			"vehicledirection": "221",
       			"vehiclemileage": "33372.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225453",
       			"todaymileage": "283.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "358",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307367",
       			"username": "135****6724",
       			"licenseplatenumber": "湘K05806D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W5N3003724",
       			"licensemainimage": "tgj168/image/2024/07/khy/1406290c-589a-4a7e-ba75-e2e2f2909e2a.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209644",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/07/khy/3b35c833-a0f3-4034-afcc-ad76842e813f.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘K7133挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/bd65c1ef156943d079a866ab7cfb7f4d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747572",
       			"dateline": "1722001478",
       			"modifytime": "1725711768",
       			"operateuid": "307367",
       			"operateuname": "135****6724",
       			"thingid": "942",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05806D",
       			"thingregnum": "05806",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848675645",
       			"outcardno": "",
       			"thingvin": "LFCAH96W5N3003724",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775418,
       			"maplng": 111.697255,
       			"mapaddr": null,
       			"staffname": "135****6724",
       			"staffmobile": "13507386724",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691758",
       			"vehiclelat": "27.778786",
       			"vehicleheight": "174",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "169209.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224919",
       			"todaymileage": "426.9",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "643",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306053",
       			"username": "13367320957",
       			"licenseplatenumber": "湘K05905D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002171",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/5a67b73a1ddf1abda4f51b6c28694258.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/5826436548d269aa2d69cb6fa4862e92.jpeg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211114",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/b412e0b9b025dcedc04a8a4ec9b7c2a1.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/649e63e09108631f2f320264f1bb6fd4.jpeg",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KC778挂",
       			"trailertypecode": "",
       			"trailerloadweight": "33",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/d4bb2fad141fd39a74bbc39c26a16b7d.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747572",
       			"dateline": "1721988570",
       			"modifytime": "1725684013",
       			"operateuid": "306053",
       			"operateuname": "13367320957",
       			"thingid": "941",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K05905D",
       			"thingregnum": "05905",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41365214897",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002171",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765716,
       			"maplng": 112.053149,
       			"mapaddr": null,
       			"staffname": "13367320957",
       			"staffmobile": "13367320957",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.047472",
       			"vehiclelat": "27.768891",
       			"vehicleheight": "121",
       			"vehiclespeed": "20.00",
       			"vehicledirection": "271",
       			"vehiclemileage": "44758.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "302.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "359",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299373",
       			"username": "181****8209",
       			"licenseplatenumber": "湘K06218D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003520",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/507ddd45fe2fe513e935cd0e7a84676e.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209652",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/cfaece5fe05ca5705a9d9dae9b4dbfd8.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KT117挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0f7a3f0ae207e3c67d7d97f92fea8cc4.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725717826",
       			"operateuid": "299373",
       			"operateuname": "181****8209",
       			"thingid": "359",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06218D",
       			"thingregnum": "06218",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846257173",
       			"outcardno": "0000002963876762",
       			"thingvin": "LFCAH96W0N3003520",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775719,
       			"maplng": 111.69753,
       			"mapaddr": null,
       			"staffname": "李鹏",
       			"staffmobile": "18152788209",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.692033",
       			"vehiclelat": "27.779086",
       			"vehicleheight": "180",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "161737.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224730",
       			"todaymileage": "395.4",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "571",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307032",
       			"username": "138****0559",
       			"licenseplatenumber": "湘K06259D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002710",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b8e378c5579dd0023fca36d3ee44c00d.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b12304199998e2f141dee26b4bc2bebc.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211289",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/1a16f7817e99a5fff89710bcbd356ff4.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KW126挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/3a94a84c37c9b481001f6be34d8f66a8.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725708585",
       			"operateuid": "307032",
       			"operateuname": "138****0559",
       			"thingid": "849",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06259D",
       			"thingregnum": "06259",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674914",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002710",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765903,
       			"maplng": 111.98108,
       			"mapaddr": null,
       			"staffname": "138****0559",
       			"staffmobile": "13873800559",
       			"taskid": "0",
       			"tasknum": "229",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975616",
       			"vehiclelat": "27.769280",
       			"vehicleheight": "126",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "28621.6",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225306",
       			"todaymileage": "333.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "361",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "301771",
       			"username": "183****2006",
       			"licenseplatenumber": "湘K06506D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W8N3003555",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/0f80a404e1f190adde4e6a966827202f.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2025-03-31",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209649",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/79441aac580416ee6594961a2b079abc.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/79441aac580416ee6594961a2b079abc.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KA727挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/d69f489e6498a9cdea1c184175620b14.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724748035",
       			"dateline": "1678693585",
       			"modifytime": "1725707084",
       			"operateuid": "301771",
       			"operateuname": "183****2006",
       			"thingid": "361",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06506D",
       			"thingregnum": "06506",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846804588",
       			"outcardno": "0000003505310105",
       			"thingvin": "LFCAH96W8N3003555",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048489,
       			"maplng": 112.971006,
       			"mapaddr": null,
       			"staffname": "刘成",
       			"staffmobile": "18373392006",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965498",
       			"vehiclelat": "28.051926",
       			"vehicleheight": "51",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "174255.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225438",
       			"todaymileage": "449.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "572",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307125",
       			"username": "199****2399",
       			"licenseplatenumber": "湘K06515D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002560",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/04848a38966a3d165e4b34666b3f4bca.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/11b17f9ce18329285fcbd7d72b8becb5.jpeg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211245",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/0355814a071de5c4c3e81f1777ed1ee9.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-14",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KK908挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/74582f3db90edbac856c6a433a945c04.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725709123",
       			"operateuid": "307125",
       			"operateuname": "199****2399",
       			"thingid": "836",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06515D",
       			"thingregnum": "06515",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674949",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002560",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049269,
       			"maplng": 112.969289,
       			"mapaddr": null,
       			"staffname": "李金龙",
       			"staffmobile": "19907322399",
       			"taskid": "0",
       			"tasknum": "222",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.963786",
       			"vehiclelat": "28.052711",
       			"vehicleheight": "30",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "26731.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225311",
       			"todaymileage": "402.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "573",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299376",
       			"username": null,
       			"licenseplatenumber": "湘K06536D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002720",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/bd6235390ef687873a6d9f986ee96b80.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/2bb85746d99b4c66f3457de4d123a0d3.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211256",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/8eba2f45e738bcbb05bd3c6cc8140417.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KL535挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/09/khy/b005dc0902d557131fedd065ef8a940e.jpeg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1725521627",
       			"dateline": "1713764524",
       			"modifytime": "1725522914",
       			"operateuid": "306420",
       			"operateuname": "淡淡的微笑",
       			"thingid": "783",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06536D",
       			"thingregnum": "06536",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674947",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002720",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.721617,
       			"maplng": 111.961583,
       			"mapaddr": null,
       			"staffname": "张荣安",
       			"staffmobile": "15080805099",
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "111.956175",
       			"vehiclelat": "27.725038",
       			"vehicleheight": "133",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "23081.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225412",
       			"todaymileage": "347.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "647",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306103",
       			"username": "肖秉理",
       			"licenseplatenumber": "湘K06585D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002186",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/363f6c9733cfe612fdba6c71e5709102.jpg",
       			"licensesideimage": "tgjffwl/image/2024/09/khy/91e5c21bfe4d8bd27f3b4c16fb69399a.jpg",
       			"licenseexpiredate": "2039-04-09",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211134",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/7cf3c0f6827a9a82a61da879d1439fcb.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/9a233eff8b6e4f633a84dd8b4ffed47c.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "93",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "10500.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KT179挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "40000",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/741f2c67ee1c6d9d362b60ffe12640e8.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724837971",
       			"dateline": "1713764524",
       			"modifytime": "1725709358",
       			"operateuid": "306103",
       			"operateuname": "13973811236",
       			"thingid": "763",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06585D",
       			"thingregnum": "06585",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357341",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002186",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970802,
       			"maplng": 111.908151,
       			"mapaddr": null,
       			"staffname": "肖秉理",
       			"staffmobile": "13973811236",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902788",
       			"vehiclelat": "27.974327",
       			"vehicleheight": "258",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "46",
       			"vehiclemileage": "40491.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225501",
       			"todaymileage": "507.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "574",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306657",
       			"username": "13397439105",
       			"licenseplatenumber": "湘K06587D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002680",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174062666201.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174062694987.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211283",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169645834000.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "10.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KM888挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0f235a0040237a4a1a6fe71a6659b406.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725703051",
       			"operateuid": "306657",
       			"operateuname": "颜建文",
       			"thingid": "850",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06587D",
       			"thingregnum": "06587",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674911",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002680",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766461,
       			"maplng": 111.980972,
       			"mapaddr": null,
       			"staffname": "13397439105",
       			"staffmobile": "13397439105",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975508",
       			"vehiclelat": "27.769838",
       			"vehicleheight": "138",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "25879.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225223",
       			"todaymileage": "331.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "362",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "293099",
       			"username": "龍????  海????",
       			"licenseplatenumber": "湘K06596D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W7N3002834",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/c9778278d0790840b721280d279ef7c4.png",
       			"licensesideimage": "tgjffwl/image/2024/09/khy/0d45ddfc689b30133e7ac10319cce924.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209650",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/4a80d5fa5068c232955cfbad7630b71e.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/09/khy/85dc08e97939dda4071ebb4382a2306f.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "93",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KH169挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/09/khy/62a37ff961202c1ecb39e78c5f4ae914.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1725190116",
       			"dateline": "1678693585",
       			"modifytime": "1725697076",
       			"operateuid": "293099",
       			"operateuname": "龍????  海????",
       			"thingid": "362",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06596D",
       			"thingregnum": "06596",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64821210340",
       			"outcardno": "0000000006099098",
       			"thingvin": "LFCAH96W7N3002834",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048784,
       			"maplng": 112.969448,
       			"mapaddr": null,
       			"staffname": "龍????  海????",
       			"staffmobile": "17775778788",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.963945",
       			"vehiclelat": "28.052225",
       			"vehicleheight": "22",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "151731.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907162625",
       			"todaymileage": "342.2",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "363",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307046",
       			"username": "廖勇",
       			"licenseplatenumber": "湘K06838D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W2N3003552",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/2bba7a5061d6e2e8a7355d123a7df2f1.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209669",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/182894f436d8962738e52d4a532236c6.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KU565挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725697766",
       			"operateuid": "307046",
       			"operateuname": "廖勇",
       			"thingid": "363",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06838D",
       			"thingregnum": "06838",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848675359",
       			"outcardno": "",
       			"thingvin": "LFCAH96W2N3003552",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766476,
       			"maplng": 111.980977,
       			"mapaddr": null,
       			"staffname": "廖勇",
       			"staffmobile": "13807386887",
       			"taskid": "0",
       			"tasknum": "227",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975513",
       			"vehiclelat": "27.769853",
       			"vehicleheight": "160",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "163027.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225330",
       			"todaymileage": "327.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "576",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307263",
       			"username": "佘明",
       			"licenseplatenumber": "湘K06965D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002567",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/7af358d157d53733663f4ae94cf3fc31.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/38889be146f750c3b5bfab138fdaea1b.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211244",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/cd308850cef29bb491abfc954a2a09cd.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K6167挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725707752",
       			"operateuid": "307263",
       			"operateuname": "159****4394",
       			"thingid": "784",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06965D",
       			"thingregnum": "06965",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674945",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002567",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910162,
       			"maplng": 111.857732,
       			"mapaddr": null,
       			"staffname": "佘明",
       			"staffmobile": "15915334394",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.852316",
       			"vehiclelat": "27.913630",
       			"vehicleheight": "174",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "111",
       			"vehiclemileage": "23382.3",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225503",
       			"todaymileage": "356.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "652",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307275",
       			"username": "周伟",
       			"licenseplatenumber": "湘K06985D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002156",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/9de9659c6ed8277dca900eefb9cee590.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/d56006ebf568be0e57d608d9528d86aa.jpg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211112",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/b46165100a2a34e1df4e5f09e4461571.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/8e3c049b402b0738b07de87cc66b8214.jpeg",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-05-28",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KW902挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/35b99fd8880e045870a1e7112dfcbe86.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "3",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"drivingLicenseMainFilename\",\"remarks\":\"行驶证正面照片有误\",\"result\":1},{\"checked\":true,\"custom\":true,\"remarks\":\"照片模糊，信息看不清\"}]",
       			"audittime": "1725701471",
       			"dateline": "1724203521",
       			"modifytime": "1725701368",
       			"operateuid": "274028",
       			"operateuname": "19911534004",
       			"thingid": "953",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K06985D",
       			"thingregnum": "06985",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40796189329",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002156",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765708,
       			"maplng": 111.980883,
       			"mapaddr": null,
       			"staffname": "周伟",
       			"staffmobile": "15073261370",
       			"taskid": "0",
       			"tasknum": "0",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975419",
       			"vehiclelat": "27.769086",
       			"vehicleheight": "141",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "31888.2",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225506",
       			"todaymileage": "349.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "579",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306071",
       			"username": "15015490281",
       			"licenseplatenumber": "湘K07106D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002601",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/7220d1a7055db037dfdbd4c2a52d06ed.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/c61325649c2c485641ae314df7926a52.jpg",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市",
       			"roadtransportnumber": "431382204891",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/a0654104a49fef1bb7002553fd0dc25d.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/a0654104a49fef1bb7002553fd0dc25d.jpg",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "49000",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KX269挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/dcdbdeff27f8ed492d8aab77f60fe536.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725705627",
       			"operateuid": "306071",
       			"operateuname": "15015490281",
       			"thingid": "837",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07106D",
       			"thingregnum": "07106",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906993",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002601",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970666,
       			"maplng": 111.908221,
       			"mapaddr": null,
       			"staffname": "15015490281",
       			"staffmobile": "15015490281",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902858",
       			"vehiclelat": "27.974191",
       			"vehicleheight": "262",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "32",
       			"vehiclemileage": "40119.7",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225454",
       			"todaymileage": "507.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "580",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307184",
       			"username": "13974119899",
       			"licenseplatenumber": "湘K07226D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002580",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/45500a872a8b3d420e738307ed07ed2f.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/467c01f002aa35d6b3da0e6aff9ab55b.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211261",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/269425c657feb448fe31e6889c39eeba.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KQ163挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a8da21faf41482abe893fbc8795e7cc5.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725713782",
       			"operateuid": "307184",
       			"operateuname": "139****9899",
       			"thingid": "772",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07226D",
       			"thingregnum": "07226",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674932",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002580",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.195088,
       			"maplng": 112.371235,
       			"mapaddr": null,
       			"staffname": "13974119899",
       			"staffmobile": "13974119899",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "112.365538",
       			"vehiclelat": "28.198288",
       			"vehicleheight": "92",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "90",
       			"vehiclemileage": "26491.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225500",
       			"todaymileage": "532.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "582",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306064",
       			"username": "19974830080",
       			"licenseplatenumber": "湘K07258D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002575",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/6c58b0ba6e09fc95014bbb85a8af2b56.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/60325ee171191859c187105c7d238c8e.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211240",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/3833f44e9daf979f028bda32399cad7f.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KJ007挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/1488a5b1a95f6c9d032ff61bd331387a.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725683290",
       			"operateuid": "306064",
       			"operateuname": "199****0080",
       			"thingid": "785",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07258D",
       			"thingregnum": "07258",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674909",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002575",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910156,
       			"maplng": 111.857782,
       			"mapaddr": null,
       			"staffname": "19974830080",
       			"staffmobile": "19974830080",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.852366",
       			"vehiclelat": "27.913625",
       			"vehicleheight": "166",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "21079.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225047",
       			"todaymileage": "532.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "682",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306058",
       			"username": "15973889466",
       			"licenseplatenumber": "湘K07389D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002179",
       			"licensemainimage": "tgjffwl/khy/2024/08/27/72af5beb74eadaad77a4c02ca926fbf9.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/27/dbd496eccbc031b1d55d1eedec4bbe84.jpg",
       			"licenseexpiredate": "2039-04-03",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211142",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/27/a3746efc7af390ea78b87d83baf6a06e.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/27/47a3e6311ddf0f420df304bf7aca6586.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KA812挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "李小青",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/442e837acd6beb3ff86d2f87d46b28a5.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724831558",
       			"dateline": "1713764524",
       			"modifytime": "1725670959",
       			"operateuid": "306058",
       			"operateuname": "15973889466",
       			"thingid": "746",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07389D",
       			"thingregnum": "07389",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357346",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002179",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970544,
       			"maplng": 111.908321,
       			"mapaddr": null,
       			"staffname": "李小青",
       			"staffmobile": "15973889466",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902958",
       			"vehiclelat": "27.974069",
       			"vehicleheight": "257",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "43",
       			"vehiclemileage": "48874.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225454",
       			"todaymileage": "325.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "583",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307370",
       			"username": "17752675883",
       			"licenseplatenumber": "湘K07736D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002603",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/72b3c4c0d66d4688ca3cbcb372ca8db4.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/97a5de68df045197a318ed9fabd1c9f1.jpeg",
       			"licenseexpiredate": "2039-04-18",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211238",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/2b81ee0e2b452dcdc4a4fe9eb04ecfde.jpeg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KH599挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/adfcbce7c15fbb917a972342063953ad.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725710638",
       			"operateuid": "307370",
       			"operateuname": "17752675883",
       			"thingid": "786",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07736D",
       			"thingregnum": "07736",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674948",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002603",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970722,
       			"maplng": 111.908157,
       			"mapaddr": null,
       			"staffname": "17752675883",
       			"staffmobile": "17752675883",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902794",
       			"vehiclelat": "27.974247",
       			"vehicleheight": "247",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "14452.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225008",
       			"todaymileage": "253.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "584",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307146",
       			"username": "134****6219",
       			"licenseplatenumber": "湘K07739D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002602",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/dd7aafb8c2f0a7bab9ef418e51cb13e9.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/dcad734002657aa1b3186eed9873ea1e.jpg",
       			"licenseexpiredate": "2039-04-18",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211257",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/00bccafd679b5b3dd66c1f45090c7bc7.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/931198000581c96b8068959e23df7833.jpg",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "H17",
       			"platecolor": "1",
       			"energytype": "C",
       			"registerdate": "2024-06-15",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "32700",
       			"loadlength": "0.00",
       			"totalweight": "40000",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KY285挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/e0654023f68d497b8a51aa6edec1662a.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725688379",
       			"operateuid": "307146",
       			"operateuname": "134****6219",
       			"thingid": "787",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07739D",
       			"thingregnum": "07739",
       			"thingpower": "2",
       			"thingcat": "重型自卸货车",
       			"vehiclecode": "40808357303",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002602",
       			"trailercode": null,
       			"thington": "32.700",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765636,
       			"maplng": 111.980975,
       			"mapaddr": null,
       			"staffname": "134****6219",
       			"staffmobile": "13467916219",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975511",
       			"vehiclelat": "27.769013",
       			"vehicleheight": "135",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "30341.6",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225428",
       			"todaymileage": "329.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "691",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K07756D",
       			"truckowner": "",
       			"identifycode": "",
       			"licensemainimage": "",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211131",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/06/04/189635_17174875397933.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": null,
       			"trucktypecode": "",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": null,
       			"usenature": "",
       			"loadweight": "0",
       			"loadlength": "0.00",
       			"totalweight": "0",
       			"curbweight": null,
       			"outlinelength": "0",
       			"outlinewidth": "0",
       			"outlineheight": "0",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "747",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07756D",
       			"thingregnum": "07756",
       			"thingpower": "2",
       			"thingcat": "牵引车",
       			"vehiclecode": "40808357345",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "0.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.396765,
       			"maplng": 113.331054,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.325611",
       			"vehiclelat": "23.399275",
       			"vehicleheight": "7",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "9",
       			"vehiclemileage": "34309.3",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225459",
       			"todaymileage": "335.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "364",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305696",
       			"username": "吴德",
       			"licenseplatenumber": "湘K07916D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W9N3003516",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/0bcc9ea5379633a645c1e8baad8783bc.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209631",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/111699bd1513514a6e03e1b64e79dc6d.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KP096挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725703961",
       			"operateuid": "305696",
       			"operateuname": "193****9590",
       			"thingid": "364",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K07916D",
       			"thingregnum": "07916",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846233366",
       			"outcardno": "",
       			"thingvin": "LFCAH96W9N3003516",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766388,
       			"maplng": 111.980962,
       			"mapaddr": null,
       			"staffname": "吴德",
       			"staffmobile": "19311749590",
       			"taskid": "22123",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.975498",
       			"vehiclelat": "27.769765",
       			"vehicleheight": "140",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "149583.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225207",
       			"todaymileage": "227.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "585",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307177",
       			"username": "135****4117",
       			"licenseplatenumber": "湘K08126D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002597",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/9045c257384d6711c0b5b4fc8b3c6250.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/0de8cf0f5cc5a6bb2ac01ea421fc13e6.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211312",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/879712a6bdbfb32b71ab64e8afe972f8.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KM887挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/79bcc918947fc6b79d212221ef1d3487.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724756372",
       			"dateline": "1714033732",
       			"modifytime": "1725712063",
       			"operateuid": "307177",
       			"operateuname": "135****4117",
       			"thingid": "851",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08126D",
       			"thingregnum": "08126",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674918",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002597",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910107,
       			"maplng": 111.857727,
       			"mapaddr": null,
       			"staffname": "135****4117",
       			"staffmobile": "13574994117",
       			"taskid": "22092",
       			"tasknum": "222",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.852311",
       			"vehiclelat": "27.913575",
       			"vehicleheight": "176",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "18001.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225143",
       			"todaymileage": "356.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "642",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307133",
       			"username": "137****6696",
       			"licenseplatenumber": "湘K08216D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002182",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/0376a3f3f0443557858d0cb20dc20dc0.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9535edea4a033faf77b0b0235d682e12.jpeg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211161",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/c3564d1f624189ae29212835bc57ade0.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/fbf3ff06e0b51df424b5832f670cd909.jpeg",
       			"transportvalidenddate": "2027-04-11",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K9567挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/822883b59fa83d0559792aa275b22687.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724826748",
       			"dateline": "1713764524",
       			"modifytime": "1725675724",
       			"operateuid": "307133",
       			"operateuname": "137****6696",
       			"thingid": "748",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08216D",
       			"thingregnum": "08216",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906967",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002182",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.726976,
       			"maplng": 111.986374,
       			"mapaddr": null,
       			"staffname": "李建六",
       			"staffmobile": "13719266696",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.980897",
       			"vehiclelat": "27.730333",
       			"vehicleheight": "109",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "40919.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225125",
       			"todaymileage": "345.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "586",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K08265D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002586",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174063403073.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174063431545.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211246",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169648152950.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KW505挂",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1724405014",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "838",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08265D",
       			"thingregnum": "08265",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674906",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002586",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473738,
       			"maplng": 113.510872,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505561",
       			"vehiclelat": "23.476344",
       			"vehicleheight": "21",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "264",
       			"vehiclemileage": "17635.6",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225453",
       			"todaymileage": "386.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "587",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307115",
       			"username": "181****8918",
       			"licenseplatenumber": "湘K08285D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002676",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174063596704.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174063636937.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211310",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169650747125.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KS892挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/20d9d14d6bf9227fb4d843fa3ea513c2.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725715531",
       			"operateuid": "307115",
       			"operateuname": "181****8918",
       			"thingid": "852",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08285D",
       			"thingregnum": "08285",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674939",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002676",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.211724,
       			"maplng": 112.453885,
       			"mapaddr": null,
       			"staffname": "181****8918",
       			"staffmobile": "18175138918",
       			"taskid": "22087",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "112.448211",
       			"vehiclelat": "28.214944",
       			"vehicleheight": "78",
       			"vehiclespeed": "56.00",
       			"vehicledirection": "75",
       			"vehiclemileage": "31473.4",
       			"vehiclewarn": "262148",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225501",
       			"todaymileage": "493.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "588",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307264",
       			"username": "沈裕",
       			"licenseplatenumber": "湘K08755D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002605",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/44e9b7361548075633f9f00dcb05ba86.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/ff35a197e4277e6eaae0490c411904a2.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211316",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/28f5483b45ba54eb468beb0ad787d474.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF268挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725711433",
       			"operateuid": "307264",
       			"operateuname": "166****5484",
       			"thingid": "853",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08755D",
       			"thingregnum": "08755",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674943",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002605",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.195617,
       			"maplng": 112.405417,
       			"mapaddr": null,
       			"staffname": "沈裕",
       			"staffmobile": "16607395484",
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.399691",
       			"vehiclelat": "28.198791",
       			"vehicleheight": "108",
       			"vehiclespeed": "70.00",
       			"vehicledirection": "275",
       			"vehiclemileage": "22432.6",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225502",
       			"todaymileage": "414.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "365",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "293124",
       			"username": "吴胜生",
       			"licenseplatenumber": "湘K08797D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3003561",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/3b8fa8992c65110e8500e3b2ade41d0c.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209668",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/4c11803b319e3bd836747011af2d9317.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KF387挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725701493",
       			"operateuid": "293124",
       			"operateuname": "为你心動",
       			"thingid": "365",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K08797D",
       			"thingregnum": "08797",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846195386",
       			"outcardno": "",
       			"thingvin": "LFCAH96W3N3003561",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765707,
       			"maplng": 111.980643,
       			"mapaddr": null,
       			"staffname": "吴胜生",
       			"staffmobile": "15243801988",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975180",
       			"vehiclelat": "27.769085",
       			"vehicleheight": "149",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "149190.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224922",
       			"todaymileage": "273.1",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "589",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307375",
       			"username": "18397602899",
       			"licenseplatenumber": "湘K09038D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002677",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b6fd7ebb75efad67810283acee597b2a.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/d0cce78173a061d74b06b41e19b50b49.jpg",
       			"licenseexpiredate": "2039-04-18",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211262",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/b44488a8a4fb63e89a35da7d3d54a40d.jpeg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "28070",
       			"loadlength": "0.00",
       			"totalweight": "38470",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K09038D",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/911dcc89593f8393d27897618ed7ed24.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725711631",
       			"operateuid": "307375",
       			"operateuname": "18397602899",
       			"thingid": "788",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K09038D",
       			"thingregnum": "09038",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674934",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002677",
       			"trailercode": null,
       			"thington": "28.070",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.985174,
       			"maplng": 111.913984,
       			"mapaddr": null,
       			"staffname": "18397602899",
       			"staffmobile": "18397602899",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.908619",
       			"vehiclelat": "27.988700",
       			"vehicleheight": "276",
       			"vehiclespeed": "41.00",
       			"vehicledirection": "218",
       			"vehiclemileage": "27792.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225454",
       			"todaymileage": "511.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "590",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307179",
       			"username": "181****2052",
       			"licenseplatenumber": "湘K09136D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002716",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/81f6333ec647cdb8fedc60b90e0755db.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/34a45cbf1fcf7fa88623a0e4828dce25.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211296",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/13b0ddccd290bb4b9c4f6ae84cc9be74.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KD535挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/b4909ede4c9afafbaba4da310e53075a.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725703084",
       			"operateuid": "307179",
       			"operateuname": "181****2052",
       			"thingid": "831",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K09136D",
       			"thingregnum": "09136",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906998",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002716",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765685,
       			"maplng": 111.980724,
       			"mapaddr": null,
       			"staffname": "181****2052",
       			"staffmobile": "18174362052",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975261",
       			"vehiclelat": "27.769063",
       			"vehicleheight": "144",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "178",
       			"vehiclemileage": "31996.0",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225506",
       			"todaymileage": "269.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "645",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307070",
       			"username": "177****4883",
       			"licenseplatenumber": "湘K09506D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002180",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ca8bbf57d19140cc2553659d25aec9a4.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/8a02053a0d19f207a61e1e26643b3b50.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211113",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/60e5311bb486def5df36239251eb863e.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/d0dde238849f8ec7c6141f20fc500979.jpg",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KQ002挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/96e5cba97e960d8ed4ee1fffec11cf85.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724830656",
       			"dateline": "1713764524",
       			"modifytime": "1725696227",
       			"operateuid": "307070",
       			"operateuname": "177****4883",
       			"thingid": "749",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K09506D",
       			"thingregnum": "09506",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357342",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002180",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.086434,
       			"maplng": 112.822322,
       			"mapaddr": null,
       			"staffname": "龙清",
       			"staffmobile": "17775934883",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.816830",
       			"vehiclelat": "28.089852",
       			"vehicleheight": "41",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "132",
       			"vehiclemileage": "31578.4",
       			"vehiclewarn": "278528",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225503",
       			"todaymileage": "540.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "603",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307147",
       			"username": "17680317338",
       			"licenseplatenumber": "湘K09626D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002352",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/55b0facb6ff9597e301d563d0dd0e99d.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b44939143f4659f231fa2e0841f24592.jpeg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211268",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/b2cfdb28b7fbd0c5fee340e80cadb667.jpeg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KZ965挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/e65d1244e8c51a4cfdad32b4a9843317.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725695174",
       			"operateuid": "307147",
       			"operateuname": "17680317338",
       			"thingid": "773",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K09626D",
       			"thingregnum": "09626",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674923",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002352",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765911,
       			"maplng": 111.981039,
       			"mapaddr": null,
       			"staffname": "17680317338",
       			"staffmobile": "17680317338",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975575",
       			"vehiclelat": "27.769288",
       			"vehicleheight": "129",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "27346.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225215",
       			"todaymileage": "346.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "706",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307033",
       			"username": "138****8589",
       			"licenseplatenumber": "湘K09836D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002689",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/fee0a51a32d9246241ce8991a1f754bd.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/a02a822d6ea9e1a1593c0c05d637d139.jpg",
       			"licenseexpiredate": "2039-05-22",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "2024-05-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211475",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/dc26d32644243d1853daa1a75e5e1bba.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/dc26d32644243d1853daa1a75e5e1bba.jpg",
       			"transportvalidenddate": "2027-05-26",
       			"trucktypecode": "H17",
       			"platecolor": "1",
       			"energytype": "C",
       			"registerdate": "2024-06-19",
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KJ962挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/55c85044739bf878e4052d90039ac240.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969592",
       			"modifytime": "1725714016",
       			"operateuid": "307033",
       			"operateuname": "13873158589",
       			"thingid": "887",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K09836D",
       			"thingregnum": "09836",
       			"thingpower": "2",
       			"thingcat": "重型自卸货车",
       			"vehiclecode": "42055906988",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002689",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765648,
       			"maplng": 111.981033,
       			"mapaddr": null,
       			"staffname": "138****8589",
       			"staffmobile": "13873158589",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975569",
       			"vehiclelat": "27.769025",
       			"vehicleheight": "134",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "28163.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225028",
       			"todaymileage": "335.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "604",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306209",
       			"username": "188****",
       			"licenseplatenumber": "湘K10089D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002671",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4293e857236229f7bca533d220776555.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/dd5a9cc857502f8f90b3ea4b62f82951.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211255",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6943de4a8d84b22e4571fdba6bad18c8.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KW708挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/5f14d78dd5d64eb177d032b7b8795b36.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725691211",
       			"operateuid": "306209",
       			"operateuname": "188****",
       			"thingid": "789",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10089D",
       			"thingregnum": "10089",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674921",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002671",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765739,
       			"maplng": 111.981125,
       			"mapaddr": null,
       			"staffname": "188****",
       			"staffmobile": "18826879380",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975661",
       			"vehiclelat": "27.769116",
       			"vehicleheight": "138",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "33881.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225122",
       			"todaymileage": "337.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "685",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306069",
       			"username": "157****",
       			"licenseplatenumber": "湘K10136D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002685",
       			"licensemainimage": "tgjffwl/khy/2024/08/27/deb4925b9c47a44b5ad45fb8dec8d71c.png",
       			"licensesideimage": "tgjffwl/khy/2024/08/27/ee67a9ab06416abb02270507462a64e3.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-24",
       			"licenseregisterdate": "2024-04-24",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211308",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/bae34558a0f9485aa9c4fa230043e552.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/bae34558a0f9485aa9c4fa230043e552.jpg",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KM905挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源市瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/fde0a850859bbfc749f40a4c09ff5e01.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724748665",
       			"dateline": "1714033732",
       			"modifytime": "1725713579",
       			"operateuid": "306069",
       			"operateuname": "157****",
       			"thingid": "858",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10136D",
       			"thingregnum": "10136",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906992",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002685",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.04918,
       			"maplng": 112.969328,
       			"mapaddr": null,
       			"staffname": "芦志红",
       			"staffmobile": "15717500408",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "112.963825",
       			"vehiclelat": "28.052622",
       			"vehicleheight": "30",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "37987.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225443",
       			"todaymileage": "401.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "646",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307072",
       			"username": "189****1273",
       			"licenseplatenumber": "湘K10156D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002187",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/bd9b6c62b44d882b21f584fa69df91e8.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/72ad097e224e6835e40fd8eadefe569d.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211105",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/fb8da8698264c8016768631c2bde8276.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/4d6cc223e5d786c963cc9d919821efc5.jpeg",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KD788挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/848fc7597029625c67ab5cbf0ce2e3f4.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725710050",
       			"operateuid": "307072",
       			"operateuname": "189****1273",
       			"thingid": "750",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10156D",
       			"thingregnum": "10156",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356960",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002187",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.244978,
       			"maplng": 112.473777,
       			"mapaddr": null,
       			"staffname": "189****1273",
       			"staffmobile": "18907431273",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.468152",
       			"vehiclelat": "28.248244",
       			"vehicleheight": "106",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "180",
       			"vehiclemileage": "39753.1",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225457",
       			"todaymileage": "333.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "367",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307031",
       			"username": "吴名灿",
       			"licenseplatenumber": "湘K10178D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W4N3002838",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/8ae0a431921abe6a6f97cb745ba6ca55.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-27",
       			"licenseregisterdate": "2022-12-27",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209639",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/027c81f0df5a2dbba52a9cd21c051fb6.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-27",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KP188挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/ddb9f9de44eff1a66454b4b02e90603c.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725702059",
       			"operateuid": "307031",
       			"operateuname": "吴名灿",
       			"thingid": "367",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10178D",
       			"thingregnum": "10178",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846257145",
       			"outcardno": "000000081499356",
       			"thingvin": "LFCAH96W4N3002838",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775753,
       			"maplng": 111.697126,
       			"mapaddr": null,
       			"staffname": "吴名灿",
       			"staffmobile": "15773888771",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691630",
       			"vehiclelat": "27.779121",
       			"vehicleheight": "170",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "143223.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224848",
       			"todaymileage": "260.5",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "638",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306050",
       			"username": "147****9576",
       			"licenseplatenumber": "湘K10216D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002181",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/e4b6dba5fd58fc1fa033bf605c2e06eb.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/28/396c8eba3d7f8fd68cada1b47c8ade39.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211133",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/62308bdd36010626b4b23bc7747f4760.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/28/d70fcd0363b5382a6a0f6ca6fe88dd01.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KE625挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/3fa4285fd72d438d415c41f0db34ff67.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724816852",
       			"dateline": "1713764524",
       			"modifytime": "1725673345",
       			"operateuid": "306050",
       			"operateuname": "147****9576",
       			"thingid": "764",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10216D",
       			"thingregnum": "10216",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356968",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002181",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776257,
       			"maplng": 111.696185,
       			"mapaddr": null,
       			"staffname": "郭晖鹏",
       			"staffmobile": "14786659576",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690691",
       			"vehiclelat": "27.779627",
       			"vehicleheight": "180",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "113",
       			"vehiclemileage": "45062.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225458",
       			"todaymileage": "351.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "655",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307080",
       			"username": "158****8251",
       			"licenseplatenumber": "湘K10222D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002220",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/7c32aee945cd758a154c2a5b1ef6926f.jpeg",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211140",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/be453907edeb33e399be58f30fc60746.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-05-28",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KC755挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "瑞麟智慧物流有限公司",
       			"carwithownerimage": "",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1724847621",
       			"operateuid": "189635",
       			"operateuname": "18975174279",
       			"thingid": "751",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10222D",
       			"thingregnum": "10222",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40796189328",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002220",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.195851,
       			"maplng": 112.3873,
       			"mapaddr": null,
       			"staffname": "158****8251",
       			"staffmobile": "15874998251",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.381583",
       			"vehiclelat": "28.199033",
       			"vehicleheight": "104",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "25918.2",
       			"vehiclewarn": "256",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240802233436",
       			"todaymileage": "42.1",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "512",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305697",
       			"username": "王继兴",
       			"licenseplatenumber": "湘K10328D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3003575",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ff2b0f5977a93e0911605c4aa5c88bf8.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209720",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/43295ab30612226ef55cfa4307a55f0b.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-05",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KN258挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1686297840",
       			"modifytime": "1725710413",
       			"operateuid": "305697",
       			"operateuname": "199****6265",
       			"thingid": "512",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10328D",
       			"thingregnum": "10328",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846237197",
       			"outcardno": "0000000814166682",
       			"thingvin": "LFCAH96W3N3003575",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049194,
       			"maplng": 112.970587,
       			"mapaddr": null,
       			"staffname": "王继兴",
       			"staffmobile": "19918926265",
       			"taskid": "0",
       			"tasknum": "217",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965080",
       			"vehiclelat": "28.052633",
       			"vehicleheight": "55",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "149968.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225109",
       			"todaymileage": "394.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "0",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": null,
       			"truckowner": null,
       			"identifycode": null,
       			"licensemainimage": null,
       			"licensesideimage": null,
       			"licenseexpiredate": null,
       			"licenseissuedate": null,
       			"licenseregisterdate": null,
       			"licenseissueorgname": null,
       			"roadtransportnumber": null,
       			"roadtransportpermitno": null,
       			"transportlicensemain": null,
       			"transportlicenseside": null,
       			"transportvalidenddate": null,
       			"trucktypecode": null,
       			"platecolor": null,
       			"energytype": null,
       			"registerdate": null,
       			"inspectionenddate": null,
       			"usenature": null,
       			"loadweight": null,
       			"loadlength": null,
       			"totalweight": null,
       			"curbweight": null,
       			"outlinelength": null,
       			"outlinewidth": null,
       			"outlineheight": null,
       			"trailerplatenumber": null,
       			"trailertypecode": null,
       			"trailerloadweight": null,
       			"businessholdsname": null,
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": null,
       			"syncstatus": null,
       			"auditstatus": null,
       			"auditmsg": null,
       			"audittime": null,
       			"dateline": "1716970797",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "897",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": null,
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10365D",
       			"thingregnum": "10365",
       			"thingpower": "2",
       			"thingcat": null,
       			"vehiclecode": "42055906983",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "40.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.371547,
       			"maplng": 113.330115,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.324675",
       			"vehiclelat": "23.374063",
       			"vehicleheight": "653",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "186",
       			"vehiclemileage": "7689.0",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "329.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "637",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307132",
       			"username": "153****2020",
       			"licenseplatenumber": "湘K10536D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002175",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/72901f0da79c649e30ad7ad4ad2864de.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/28/ee8d3753eef31818364feb0f36a7519a.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211146",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/5a3dc252add7825f812017ae378e010e.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/28/9b6f8f4bd3d2f688ab6cc4adb1af5df7.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KN176挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/cd22f43693a578e42b0dfe29662727fb.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724826978",
       			"dateline": "1713764524",
       			"modifytime": "1725700321",
       			"operateuid": "307132",
       			"operateuname": "153****2020",
       			"thingid": "752",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10536D",
       			"thingregnum": "10536",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41365214895",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002175",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776196,
       			"maplng": 111.695921,
       			"mapaddr": null,
       			"staffname": "吴海波",
       			"staffmobile": "15347382020",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690427",
       			"vehiclelat": "27.779566",
       			"vehicleheight": "188",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "31889.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225142",
       			"todaymileage": "347.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "369",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305698",
       			"username": "李浩",
       			"licenseplatenumber": "湘K10538D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W9N3002589",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/f58742fc1eec5bd9631ba468effafb30.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209643",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/b5f579ef816ff2f36e2f1a6b115cad2d.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KB068挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725704594",
       			"operateuid": "305698",
       			"operateuname": "186****8160",
       			"thingid": "369",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10538D",
       			"thingregnum": "10538",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846257640",
       			"outcardno": "0000001085677978",
       			"thingvin": "LFCAH96W9N3002589",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048965,
       			"maplng": 112.96955,
       			"mapaddr": null,
       			"staffname": "李浩",
       			"staffmobile": "18673128160",
       			"taskid": "0",
       			"tasknum": "223",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.964046",
       			"vehiclelat": "28.052406",
       			"vehicleheight": "46",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "172929.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224800",
       			"todaymileage": "87.4",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "724",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306885",
       			"username": "134****7769",
       			"licenseplatenumber": "湘K10833D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002712",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/5ed27abaaceb27d89c16bcda997bb65c.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/bd1ce817cdda12a096ae008f203b8b31.jpg",
       			"licenseexpiredate": "2039-05-24",
       			"licenseissuedate": "2024-05-24",
       			"licenseregisterdate": "2024-05-24",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211501",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/09c620b53010793fd79c3cdb701feddb.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/09c620b53010793fd79c3cdb701feddb.jpg",
       			"transportvalidenddate": "2027-05-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KD965挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/37a5cc15829c5eb9492dfff910f0d59b.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716970822",
       			"modifytime": "1725698320",
       			"operateuid": "306885",
       			"operateuname": "134****7769",
       			"thingid": "898",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10833D",
       			"thingregnum": "10833",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906977",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002712",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.067102,
       			"maplng": 112.994237,
       			"mapaddr": null,
       			"staffname": "134****7769",
       			"staffmobile": "13450597769",
       			"taskid": "22105",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "112.988647",
       			"vehiclelat": "28.070477",
       			"vehicleheight": "65",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "150",
       			"vehiclemileage": "21660.0",
       			"vehiclewarn": "262148",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225459",
       			"todaymileage": "567.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "690",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K10926D",
       			"truckowner": "",
       			"identifycode": "",
       			"licensemainimage": "",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211143",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/06/04/189635_17174874383467.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": null,
       			"trucktypecode": "",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": null,
       			"usenature": "",
       			"loadweight": "0",
       			"loadlength": "0.00",
       			"totalweight": "0",
       			"curbweight": null,
       			"outlinelength": "0",
       			"outlinewidth": "0",
       			"outlineheight": "0",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "753",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K10926D",
       			"thingregnum": "10926",
       			"thingpower": "2",
       			"thingcat": "牵引车",
       			"vehiclecode": "40808356965",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "0.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.37182,
       			"maplng": 113.330315,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.324875",
       			"vehiclelat": "23.374336",
       			"vehicleheight": "3",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "170",
       			"vehiclemileage": "34112.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225504",
       			"todaymileage": "332.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "605",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307176",
       			"username": "134****4862",
       			"licenseplatenumber": "湘K11056D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002585",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/37918804febeb60743c1d151e73c2e56.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/403fbe4008d503903840cfc2dff8c376.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211252",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/d90e7773030bb66f6bd61e6226684f75.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K8818挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/e9d5e478de67ad85cd81897513b251e0.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838831",
       			"dateline": "1714033732",
       			"modifytime": "1725714061",
       			"operateuid": "307176",
       			"operateuname": "134****4862",
       			"thingid": "839",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11056D",
       			"thingregnum": "11056",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674916",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002585",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765692,
       			"maplng": 111.981033,
       			"mapaddr": null,
       			"staffname": "阳范超",
       			"staffmobile": "13434574862",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975569",
       			"vehiclelat": "27.769069",
       			"vehicleheight": "128",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "38609.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225130",
       			"todaymileage": "344.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "648",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307128",
       			"username": "150****2272",
       			"licenseplatenumber": "湘K11506D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002216",
       			"licensemainimage": "tgjffwl/khy/2024/08/27/cf93e8911e618f0f2ad9b09559cca700.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/27/2e866d87052346970628e7d0d6f80910.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211129",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/27/5d1397f6e40ac26ecc9871ebd0768e18.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/27/91bf851f41201be58b860a90a7a144db.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KB799挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c5b15555ad639198731a5497c6947eb3.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724749769",
       			"dateline": "1713764524",
       			"modifytime": "1725712669",
       			"operateuid": "307128",
       			"operateuname": "150****2272",
       			"thingid": "765",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11506D",
       			"thingregnum": "11506",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357343",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002216",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.77552,
       			"maplng": 111.697084,
       			"mapaddr": null,
       			"staffname": "周林",
       			"staffmobile": "15096382272",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691588",
       			"vehiclelat": "27.778888",
       			"vehicleheight": "164",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "41134.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225448",
       			"todaymileage": "432.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "370",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "304438",
       			"username": "18773280009",
       			"licenseplatenumber": "湘K11516D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W7N3003546",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e6ec8296e3072f4595f56e76b193fb2b.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/0b4617cd8887c91b7daa1a598a55f1fa.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209629",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6c1d72a47473e722dd93baf0dbd8b7fa.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/b36eaa20a1e544fea2e80f7324a18bab.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KF515挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9bccc5d9557b0e4aaa6e775537fea7f7.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724812676",
       			"dateline": "1678693585",
       			"modifytime": "1725696860",
       			"operateuid": "304438",
       			"operateuname": "18773280009",
       			"thingid": "370",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11516D",
       			"thingregnum": "11516",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846210588",
       			"outcardno": "0000000551414425",
       			"thingvin": "LFCAH96W7N3003546",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766527,
       			"maplng": 111.980895,
       			"mapaddr": null,
       			"staffname": "龙韶源",
       			"staffmobile": "18773280009",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975431",
       			"vehiclelat": "27.769905",
       			"vehicleheight": "144",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "160173.7",
       			"vehiclewarn": "32",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225450",
       			"todaymileage": "203.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "654",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306066",
       			"username": "199****9879",
       			"licenseplatenumber": "湘K11535D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002215",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/733fa39fd5b3e15e8a06858e0f43e1cc.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/6a0547ead2f3e6d953f90c6b641f9997.jpg",
       			"licenseexpiredate": "2039-04-03",
       			"licenseissuedate": "2024-04-03",
       			"licenseregisterdate": "2024-04-03",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211147",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/cb1739e81d9fc4fd14be662e9531a940.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/d21742f2fb77020009800ec3d6ec5cfb.jpeg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q31",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KG606挂",
       			"trailertypecode": "B31",
       			"trailerloadweight": "38470",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c51b0b8afbff56d3b1de41153ba8bdbe.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724807122",
       			"dateline": "1713764524",
       			"modifytime": "1725712405",
       			"operateuid": "306066",
       			"operateuname": "18890594716",
       			"thingid": "754",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11535D",
       			"thingregnum": "11535",
       			"thingpower": "2",
       			"thingcat": "轻型半挂牵引车",
       			"vehiclecode": "40808356957",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002215",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970494,
       			"maplng": 111.908299,
       			"mapaddr": null,
       			"staffname": "李总兵",
       			"staffmobile": "18890594716",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902936",
       			"vehiclelat": "27.974019",
       			"vehicleheight": "237",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "34530.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224715",
       			"todaymileage": "253.2",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "606",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307233",
       			"username": "138****4088",
       			"licenseplatenumber": "湘K11536D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W5R3002596",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/46eefbf9b9556efa03295f6d093b836f.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/c03f7af1230267032acf1718b3cf511b.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211279",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/746da171e586a9ad585de84bbd9cfe6d.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KB785挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/2044a11255183a2aa83e434954aede56.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "3",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"axles\",\"remarks\":\"车辆轴数有误\",\"result\":1}]",
       			"audittime": "1724827409",
       			"dateline": "1713764524",
       			"modifytime": "1725626623",
       			"operateuid": "307233",
       			"operateuname": "138****4088",
       			"thingid": "790",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11536D",
       			"thingregnum": "11536",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674919",
       			"outcardno": "",
       			"thingvin": "LFXAH76W5R3002596",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.183995,
       			"maplng": 112.638323,
       			"mapaddr": null,
       			"staffname": "肖赛东",
       			"staffmobile": "13874304088",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.632969",
       			"vehiclelat": "28.187511",
       			"vehicleheight": "85",
       			"vehiclespeed": "79.00",
       			"vehicledirection": "159",
       			"vehiclemileage": "39783.0",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "511.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "341",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300736",
       			"username": "138****6311",
       			"licenseplatenumber": "湘K11567D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W2N3003583",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b96bef7cb538656c9a9f7df3a5d88f58.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/49c3502bc8269dcad32ad449d60ba2f9.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209659",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/8b3096ce409b9eba20ff8ad14c2f7e09.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/950bd0621462a7c1186c49c6d4904920.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KB697挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/7c29d975af9a55f43b7480d312a1acfb.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747656",
       			"dateline": "1678693585",
       			"modifytime": "1725714519",
       			"operateuid": "300736",
       			"operateuname": "138****6311",
       			"thingid": "341",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11567D",
       			"thingregnum": "11567",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846215013",
       			"outcardno": "",
       			"thingvin": "LFCAH96W2N3003583",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048875,
       			"maplng": 112.969862,
       			"mapaddr": null,
       			"staffname": "138****6311",
       			"staffmobile": "13875856311",
       			"taskid": "0",
       			"tasknum": "218",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.964358",
       			"vehiclelat": "28.052315",
       			"vehicleheight": "47",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "167872.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225217",
       			"todaymileage": "455.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "653",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307168",
       			"username": "18073886776",
       			"licenseplatenumber": "湘K11595D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002150",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ea9fb727f75c9da8b248c33114389b4e.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/786e572af6bf649ccbbca34bdf763e69.jpeg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211115",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/f3f06e84b2181eabf0ce7e11979df83e.jpeg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KW392挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c745394de75c14b31161225b87a19d5e.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "0",
       			"dateline": "1713764524",
       			"modifytime": "1725695455",
       			"operateuid": "307168",
       			"operateuname": "18073886776",
       			"thingid": "755",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11595D",
       			"thingregnum": "11595",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357339",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002150",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765903,
       			"maplng": 111.980989,
       			"mapaddr": null,
       			"staffname": "18073886776",
       			"staffmobile": "18073886776",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975525",
       			"vehiclelat": "27.769280",
       			"vehicleheight": "125",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "30173.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225219",
       			"todaymileage": "338.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "371",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "303933",
       			"username": "卜凯",
       			"licenseplatenumber": "湘K11829D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3003560",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/13893d4cf73548b5a0ee1fd881b8e9b8.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209675",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/92890de614c6ae473479c719fc9f7f28.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KV125挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725715392",
       			"operateuid": "303933",
       			"operateuname": "13667494119",
       			"thingid": "371",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K11829D",
       			"thingregnum": "11829",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846256891",
       			"outcardno": "000000162522204",
       			"thingvin": "LFCAH96W1N3003560",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049067,
       			"maplng": 112.969458,
       			"mapaddr": null,
       			"staffname": "卜凯",
       			"staffmobile": "13667494119",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.963955",
       			"vehiclelat": "28.052508",
       			"vehicleheight": "79",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "169624.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224759",
       			"todaymileage": "395.1",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "607",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306658",
       			"username": "159****5520",
       			"licenseplatenumber": "湘K12269D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002673",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/d536232ba1aac6a025f5a63dcf54fe93.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b913226d22221ff615bde745698fcb46.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211241",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/3e1ae074e76f4a2649672328394f68eb.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KK906挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c4facc84f6cc2d4cbcc0698f86b76031.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725676253",
       			"operateuid": "306658",
       			"operateuname": "159****5520",
       			"thingid": "774",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12269D",
       			"thingregnum": "12269",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674925",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002673",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766381,
       			"maplng": 111.981116,
       			"mapaddr": null,
       			"staffname": "159****5520",
       			"staffmobile": "15973085520",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975652",
       			"vehiclelat": "27.769758",
       			"vehicleheight": "123",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "23392.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225315",
       			"todaymileage": "332.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "715",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305135",
       			"username": "158****8152",
       			"licenseplatenumber": "湘K12665D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002715",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a847872901a1f85e1ce728950f851c2d.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/be63a773bf2fa63c1a345890be75a601.jpg",
       			"licenseexpiredate": "2039-05-25",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "2024-05-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211484",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/ed69256b141c35b081f40721701b8a39.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/304685252455d1686065f7fe4bc6333b.jpg",
       			"transportvalidenddate": "2027-05-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KA615挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/3cd99bd77675180b36272c5d524424ef.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969617",
       			"modifytime": "1725704158",
       			"operateuid": "305135",
       			"operateuname": "158****8152",
       			"thingid": "888",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12665D",
       			"thingregnum": "12665",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906985",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002715",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910143,
       			"maplng": 111.857704,
       			"mapaddr": null,
       			"staffname": "158****8152",
       			"staffmobile": "15873898152",
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.852288",
       			"vehiclelat": "27.913611",
       			"vehicleheight": "171",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "19299.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225122",
       			"todaymileage": "428.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "712",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307437",
       			"username": "廖志彪",
       			"licenseplatenumber": "湘K12698D",
       			"truckowner": "漣源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002686",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/eb016fb5e8fc5f07991f70a1d2b97560.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/2e46609a3ef6d72dada0cd8ed7ac89c8.jpg",
       			"licenseexpiredate": "2039-05-24",
       			"licenseissuedate": "2024-05-24",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省婁底市公安局交通警察支隊",
       			"roadtransportnumber": "431382211503",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/eb1de7cf3a272fcc49fe239aff8f00c5.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/3676919f4c4e67e0a14951eadc661b3f.jpg",
       			"transportvalidenddate": "",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "28070",
       			"loadlength": "0.00",
       			"totalweight": "38470",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KA066挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "漣源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/7911a585ed85c9d1bf2a4da17f2dbd0d.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"validEndDate\",\"remarks\":\"运输证有效期有误\",\"result\":1}]",
       			"audittime": "1725520849",
       			"dateline": "1716970562",
       			"modifytime": "1725713700",
       			"operateuid": "307437",
       			"operateuname": "13319682229",
       			"thingid": "895",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12698D",
       			"thingregnum": "12698",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906978",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002686",
       			"trailercode": null,
       			"thington": "28.070",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910359,
       			"maplng": 111.857517,
       			"mapaddr": null,
       			"staffname": "廖志彪",
       			"staffmobile": "13319682229",
       			"taskid": "22105",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "15",
       			"applystatus": "0",
       			"operatemsg": "货运司机已接单",
       			"vehiclelng": "111.852100",
       			"vehiclelat": "27.913827",
       			"vehicleheight": "175",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "19492.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225444",
       			"todaymileage": "355.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "687",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K12825D",
       			"truckowner": "",
       			"identifycode": "",
       			"licensemainimage": "",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211163",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/06/04/189635_17174869889192.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": null,
       			"trucktypecode": "",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": null,
       			"usenature": "",
       			"loadweight": "0",
       			"loadlength": "0.00",
       			"totalweight": "0",
       			"curbweight": null,
       			"outlinelength": "0",
       			"outlinewidth": "0",
       			"outlineheight": "0",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "760",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12825D",
       			"thingregnum": "12825",
       			"thingpower": "2",
       			"thingcat": "牵引车",
       			"vehiclecode": "40808356956",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "0.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.38096,
       			"maplng": 112.026777,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "112.021200",
       			"vehiclelat": "27.384200",
       			"vehicleheight": "120",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "5.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240412114943",
       			"todaymileage": "0",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "608",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307069",
       			"username": "18207439110",
       			"licenseplatenumber": "湘K12906D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002571",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e56309b48f7e7d6bb66f4839d4af7671.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/4ba8f826746485082c1ed8dc09a42e70.jpg",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211281",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/4259e62261dfda8f1d8bf97769a91f47.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-18",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KB816挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/09a095f95ff87bd1bdcdece71cad7380.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724831969",
       			"dateline": "1713764524",
       			"modifytime": "1725704668",
       			"operateuid": "307069",
       			"operateuname": "18207439110",
       			"thingid": "791",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12906D",
       			"thingregnum": "12906",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674907",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002571",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.245009,
       			"maplng": 112.473755,
       			"mapaddr": null,
       			"staffname": "施伟龙",
       			"staffmobile": "18207439110",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.468130",
       			"vehiclelat": "28.248275",
       			"vehicleheight": "108",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "175",
       			"vehiclemileage": "22228.0",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225454",
       			"todaymileage": "334.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "373",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300279",
       			"username": "13958802469",
       			"licenseplatenumber": "湘K12956D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96WXN3003573",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/926f16a6d8ce3770efdd11d51b535838.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209635",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/05cdb52b2d5fc40094545255435d4a84.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KW276挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/53f9eba2d32d25b08281a85becd0bff5.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724814226",
       			"dateline": "1678693585",
       			"modifytime": "1725705103",
       			"operateuid": "300279",
       			"operateuname": "13958802469",
       			"thingid": "373",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12956D",
       			"thingregnum": "12956",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846194716",
       			"outcardno": "0000003763639705",
       			"thingvin": "LFCAH96WXN3003573",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048578,
       			"maplng": 112.970797,
       			"mapaddr": null,
       			"staffname": "杨波",
       			"staffmobile": "13958802469",
       			"taskid": "0",
       			"tasknum": "222",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965290",
       			"vehiclelat": "28.052016",
       			"vehicleheight": "39",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "160466.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225452",
       			"todaymileage": "343.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "175",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "293132",
       			"username": "沧海一栗",
       			"licenseplatenumber": "湘K12968D",
       			"truckowner": "湖南屹上科技有限公司",
       			"identifycode": "LFCAH96W9N3001023",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e00fb9310b766be7822e12df06ba0464.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-06-24",
       			"licenseregisterdate": "2022-06-24",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382208399",
       			"roadtransportpermitno": "431382204156",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6d8e7bc40f6c876a8d5e455b6cea14ae.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2025-06-29",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37670",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KB395挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "湖南屹上科技有限公司",
       			"carwithownerimage": "",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747656",
       			"dateline": "1664270001",
       			"modifytime": "1725715911",
       			"operateuid": "293132",
       			"operateuname": "沧海一栗",
       			"thingid": "175",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "湖南屹上科技有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K12968D",
       			"thingregnum": "12968",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41086302450",
       			"outcardno": "0000001881853081",
       			"thingvin": "LFCAH96W9N3001023",
       			"trailercode": null,
       			"thington": "37.670",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766409,
       			"maplng": 111.981185,
       			"mapaddr": null,
       			"staffname": "沧海一栗",
       			"staffmobile": "15347382878",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975720",
       			"vehiclelat": "27.769786",
       			"vehicleheight": "154",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "90",
       			"vehiclemileage": "15354.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225153",
       			"todaymileage": "240.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "726",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307332",
       			"username": "189****6879",
       			"licenseplatenumber": "湘K13026D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LA9964E31R0HSN082",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/cfbf452ba3d60a68a05281fbb49c568d.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/4523c5234110f2d31e324980dbd8c908.jpg",
       			"licenseexpiredate": "2039-05-24",
       			"licenseissuedate": "2024-05-24",
       			"licenseregisterdate": "2024-05-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211508",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/2d03aa7ae5212624d4a4548e76303ba4.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/2d03aa7ae5212624d4a4548e76303ba4.jpg",
       			"transportvalidenddate": "2027-05-29",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KQ526挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/e90a449c3f4321c41c98c70c325f485d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969644",
       			"modifytime": "1725704171",
       			"operateuid": "307332",
       			"operateuname": "18973816879",
       			"thingid": "889",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13026D",
       			"thingregnum": "13026",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906975",
       			"outcardno": "",
       			"thingvin": "LA9964E31R0HSN082",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765616,
       			"maplng": 111.980858,
       			"mapaddr": null,
       			"staffname": "189****6879",
       			"staffmobile": "18973816879",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.975394",
       			"vehiclelat": "27.768994",
       			"vehicleheight": "144",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "8416.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225126",
       			"todaymileage": "293.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "458",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300691",
       			"username": "蒋国平",
       			"licenseplatenumber": "湘K13179D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3003558",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/93554a108815d823978f78949b5ca2ae.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209662",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6b4ded7e8b65c9b7cba6b8539a72afeb.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KC168挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1685148960",
       			"modifytime": "1725107417",
       			"operateuid": "300691",
       			"operateuname": "133****0395",
       			"thingid": "458",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13179D",
       			"thingregnum": "13179",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846801583",
       			"outcardno": "0000000005852314",
       			"thingvin": "LFCAH96W3N3003558",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765977,
       			"maplng": 111.980912,
       			"mapaddr": null,
       			"staffname": "蒋国平",
       			"staffmobile": "13347330395",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975448",
       			"vehiclelat": "27.769355",
       			"vehicleheight": "143",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "162618.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225354",
       			"todaymileage": "391.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "375",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "303798",
       			"username": "15367381588",
       			"licenseplatenumber": "湘K13258D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3003723",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ef8c3b12e5e5888f8038fbb957da9381.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/f0d70bb23184949744345f091c317035.jpg",
       			"licenseexpiredate": "2037-12-30",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209642",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/4b2a3662904e6d935159c6d752aa48bb.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KN505挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/9d1116c407b2ccd7a86e44e06a3463e9.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725710079",
       			"operateuid": "303798",
       			"operateuname": "15367381588",
       			"thingid": "375",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13258D",
       			"thingregnum": "13258",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846803974",
       			"outcardno": "",
       			"thingvin": "LFCAH96W3N3003723",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.76585,
       			"maplng": 111.980754,
       			"mapaddr": null,
       			"staffname": "15367381588",
       			"staffmobile": "15367381588",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975291",
       			"vehiclelat": "27.769228",
       			"vehicleheight": "130",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "162847.6",
       			"vehiclewarn": "524288",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225445",
       			"todaymileage": "311.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "649",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307112",
       			"username": "18570324298",
       			"licenseplatenumber": "湘K13378D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002173",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/7eecd76cfd50e4e3ed1db7d7b740f6d1.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/639e1183d33bc01f444c2bd807b471e6.jpg",
       			"licenseexpiredate": "2039-04-09",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211139",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/47ca8062feb286d9790615360b053c35.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/9066e7a0a5683a685cfa6410832ada2a.jpg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "1",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KM388挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/813e9ec3e77b27c7a6e00a97f67f2492.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"truckTypeCode\",\"remarks\":\"车辆类型有误\",\"result\":1}]",
       			"audittime": "1724837555",
       			"dateline": "1713764524",
       			"modifytime": "1725716999",
       			"operateuid": "307112",
       			"operateuname": "185****4298",
       			"thingid": "766",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13378D",
       			"thingregnum": "13378",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357344",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002173",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.148939,
       			"maplng": 112.143416,
       			"mapaddr": null,
       			"staffname": "肖洪标",
       			"staffmobile": "18570324298",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.137697",
       			"vehiclelat": "28.152144",
       			"vehicleheight": "104",
       			"vehiclespeed": "59.00",
       			"vehicledirection": "258",
       			"vehiclemileage": "23892.8",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225459",
       			"todaymileage": "451.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "714",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307182",
       			"username": "173****3862",
       			"licenseplatenumber": "湘K13538D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3000383",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/612fa66cac3c922fc2a04387d4eb8838.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/092f8cce084ab532776697bfb575eac5.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-05-21",
       			"licenseregisterdate": "2024-05-21",
       			"licenseissueorgname": "娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211505",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/c5b67b91eef16f482ea1406ab9fa818d.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/e9f3580e3eeda43e50196aae1dd2ee37.jpg",
       			"transportvalidenddate": "2027-05-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KJ278挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/25e41ca5d9bcff3a841472b935b4e09c.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969667",
       			"modifytime": "1725708883",
       			"operateuid": "307182",
       			"operateuname": "173****3862",
       			"thingid": "890",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13538D",
       			"thingregnum": "13538",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906990",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3000383",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.231394,
       			"maplng": 112.555646,
       			"mapaddr": null,
       			"staffname": "173****3862",
       			"staffmobile": "17363783862",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.550272",
       			"vehiclelat": "28.234886",
       			"vehicleheight": "61",
       			"vehiclespeed": "18.00",
       			"vehicledirection": "106",
       			"vehiclemileage": "24221.1",
       			"vehiclewarn": "4",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "559.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "644",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306062",
       			"username": "193****5588",
       			"licenseplatenumber": "湘K13558D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002167",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/dc891aedb5684bc520267fbb0ea51618.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/28/eae2b4126cc441393657ae1ce853fd41.jpg",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211110",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/92f612953cb98e225ab66e4b08314cf5.jpg",
       			"transportlicenseside": "tgjffwl/khy/2024/08/28/564937affab3cfbc6c56844afe5a4689.jpg",
       			"transportvalidenddate": "2027-04-18",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K9178挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/b10d195e13990371bd78d5e0ed7b91e0.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724830830",
       			"dateline": "1713764524",
       			"modifytime": "1725705161",
       			"operateuid": "306062",
       			"operateuname": "193****5588",
       			"thingid": "756",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13558D",
       			"thingregnum": "13558",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356962",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002167",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970669,
       			"maplng": 111.908232,
       			"mapaddr": null,
       			"staffname": "颜乐君",
       			"staffmobile": "19386885588",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902869",
       			"vehiclelat": "27.974194",
       			"vehicleheight": "265",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "38",
       			"vehiclemileage": "46007.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "502.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "609",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307059",
       			"username": "134****1190",
       			"licenseplatenumber": "湘K13996D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002668",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e6fe3de03d3923beaf45023c49a3cf58.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/f3b4e0c18d99cffbc62e6260e966a55f.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211265",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/8ccd889d602e8b52a660370867859a12.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KV008挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/2c8d40082f32b6fed19b595e86222408.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838063",
       			"dateline": "1713764524",
       			"modifytime": "1725714551",
       			"operateuid": "307059",
       			"operateuname": "134****1190",
       			"thingid": "792",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K13996D",
       			"thingregnum": "13996",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674922",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002668",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.195538,
       			"maplng": 112.406253,
       			"mapaddr": null,
       			"staffname": "隆海长",
       			"staffmobile": "13487961190",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.400527",
       			"vehiclelat": "28.198711",
       			"vehicleheight": "97",
       			"vehiclespeed": "68.00",
       			"vehicledirection": "276",
       			"vehiclemileage": "17880.7",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225506",
       			"todaymileage": "416.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "610",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306074",
       			"username": "133****0955",
       			"licenseplatenumber": "湘K15106D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002682",
       			"licensemainimage": "tgj168/image/2024/06/04/189635_17174881213266.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211232",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169654124552.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KU635挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0e00b5cb759be2f91c7befaa66ad3772.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725699537",
       			"operateuid": "306074",
       			"operateuname": "133****0955",
       			"thingid": "840",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15106D",
       			"thingregnum": "15106",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674935",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002682",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048512,
       			"maplng": 112.97086,
       			"mapaddr": null,
       			"staffname": "133****0955",
       			"staffmobile": "13378030955",
       			"taskid": "0",
       			"tasknum": "220",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "112.965352",
       			"vehiclelat": "28.051950",
       			"vehicleheight": "44",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "142",
       			"vehiclemileage": "38123.2",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225457",
       			"todaymileage": "397.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "342",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299630",
       			"username": "李均明",
       			"licenseplatenumber": "湘K15109D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3003722",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/dad5beca699ee1f6677fd4c152e01b79.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b912e0611c182d7844aa6225269a1f59.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209632",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/289a27b8d71c12a76913761326041486.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/fae466dfd8a0003e6a599ea3a37b7125.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KX526挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747656",
       			"dateline": "1678693585",
       			"modifytime": "1725712871",
       			"operateuid": "299630",
       			"operateuname": "15273862177",
       			"thingid": "342",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15109D",
       			"thingregnum": "15109",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848677665",
       			"outcardno": "0000002430022554",
       			"thingvin": "LFCAH96W1N3003722",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766515,
       			"maplng": 111.980869,
       			"mapaddr": null,
       			"staffname": "李均明",
       			"staffmobile": "15273862177",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975405",
       			"vehiclelat": "27.769893",
       			"vehicleheight": "149",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "152541.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224701",
       			"todaymileage": "320.4",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "550",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300985",
       			"username": "谭勇",
       			"licenseplatenumber": "湘K15119D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W9N3003726",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4f9c3a13a5a0cb1ef8e6a2a77c43fe3f.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/cc95f72f50ecb14dd73f21ae427618db.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209634",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/55b30eb71f7e45e994d558e03d64b476.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/ef9035f597b5fe17c3c1132135511979.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KL728挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725669490",
       			"operateuid": "300985",
       			"operateuname": "157****8621",
       			"thingid": "376",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15119D",
       			"thingregnum": "15119",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848677156",
       			"outcardno": "0000002152662426",
       			"thingvin": "LFCAH96W9N3003726",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766455,
       			"maplng": 111.980801,
       			"mapaddr": null,
       			"staffname": "谭勇",
       			"staffmobile": "15773888621",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975338",
       			"vehiclelat": "27.769833",
       			"vehicleheight": "155",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "166999.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224811",
       			"todaymileage": "233.0",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "611",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306207",
       			"username": "15197830875",
       			"licenseplatenumber": "湘K15126D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W8R3002690",
       			"licensemainimage": "tgj168/image/2024/06/04/189635_17174862502423.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/3f4c3bff510d6a82e3d99fd9aa1c734d.jpg",
       			"licenseexpiredate": "2025-04-16",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211263",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/28/189635_17168869408907.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/3da9b7690408b9dcf586034dbaa0f1ea.jpg",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KV085挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/018597354eed381f0ea56a55bce805f9.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725681935",
       			"operateuid": "306207",
       			"operateuname": "151****0875",
       			"thingid": "775",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15126D",
       			"thingregnum": "15126",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357300",
       			"outcardno": "",
       			"thingvin": "LFXAH76W8R3002690",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.76575,
       			"maplng": 111.981014,
       			"mapaddr": null,
       			"staffname": "15197830875",
       			"staffmobile": "15197830875",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975550",
       			"vehiclelat": "27.769127",
       			"vehicleheight": "141",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "37075.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225133",
       			"todaymileage": "335.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "689",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K15286D",
       			"truckowner": "",
       			"identifycode": "",
       			"licensemainimage": "",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211145",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/06/04/189635_17174872137237.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": null,
       			"trucktypecode": "",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": null,
       			"usenature": "",
       			"loadweight": "0",
       			"loadlength": "0.00",
       			"totalweight": "0",
       			"curbweight": null,
       			"outlinelength": "0",
       			"outlinewidth": "0",
       			"outlineheight": "0",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "757",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15286D",
       			"thingregnum": "15286",
       			"thingpower": "2",
       			"thingcat": "牵引车",
       			"vehiclecode": "40808357347",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "0.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473724,
       			"maplng": 113.510961,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505650",
       			"vehiclelat": "23.476330",
       			"vehicleheight": "15",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "32033.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225300",
       			"todaymileage": "181.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "377",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "303678",
       			"username": "13431884552",
       			"licenseplatenumber": "湘K15579D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W9N3002835",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ade608672d6163000f8427b34708fdd9.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/4c315b6492bdb60b2f991de36cbf4bd7.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209677",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/dd0e45aa84e0944bdacfeb0a83ce137f.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/9949e9f7bf03760b95d164d5a5105f8f.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KM083挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/018ad8a8bb954fdf5871477daae7e094.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725715598",
       			"operateuid": "303678",
       			"operateuname": "13431884552",
       			"thingid": "377",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K15579D",
       			"thingregnum": "15579",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846257259",
       			"outcardno": "0000000003461785",
       			"thingvin": "LFCAH96W9N3002835",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775662,
       			"maplng": 111.697167,
       			"mapaddr": null,
       			"staffname": "13431884552",
       			"staffmobile": "13431884552",
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.691671",
       			"vehiclelat": "27.779030",
       			"vehicleheight": "169",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "168528.8",
       			"vehiclewarn": "524288",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225441",
       			"todaymileage": "417.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "378",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299369",
       			"username": "廖立加",
       			"licenseplatenumber": "湘K15628D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W5N3003576",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ceb46a1e83499347d73b8f36e85de435.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/50a5d972170c2fdd75f88445772d9fbc.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209636",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/47930df12b4f4b41e073d9fa2b77225c.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/aa0ca79eda108384eb72dbe5b6eb145e.jpg",
       			"transportvalidenddate": "1970-01-01",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KY529挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725705924",
       			"operateuid": "299369",
       			"operateuname": "189****5569",
       			"thingid": "378",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "§å»ºæ¥",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K15628D",
       			"thingregnum": "15628",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "64846223990",
       			"outcardno": "0000001621447578",
       			"thingvin": "LFCAH96W5N3003576",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775682,
       			"maplng": 111.697136,
       			"mapaddr": null,
       			"staffname": "å»ç«å ",
       			"staffmobile": "18973815569",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "è´§è¿å¸æºå·²å®å·¥",
       			"vehiclelng": "111.691640",
       			"vehiclelat": "27.779050",
       			"vehicleheight": "181",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "176251.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225153",
       			"todaymileage": "298.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "379",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "307353",
       			"username": "ç½å°ç°",
       			"licenseplatenumber": "æ¹K15629D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFCAH96W7N3003725",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ce4bf5609c99afcc4b1eb37ee36c79e9.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/c9a4c89fa2577942668dc2d445fa5e51.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382209653",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/5ea9ab1632ddd1e701ad32fefb009815.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/bbe8c8c17a31293759fad375f5e91a26.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "è´§è¿",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "æ¹KX077æ",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725714449",
       			"operateuid": "307353",
       			"operateuname": "19918805088",
       			"thingid": "379",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "è§å»ºæ¥",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K15629D",
       			"thingregnum": "15629",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "64848676983",
       			"outcardno": "0000001883391130",
       			"thingvin": "LFCAH96W7N3003725",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049294,
       			"maplng": 112.969351,
       			"mapaddr": null,
       			"staffname": "ç½å°ç°",
       			"staffmobile": "19918805088",
       			"taskid": "0",
       			"tasknum": "212",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "è´§è¿å¸æºå·²å®å·¥",
       			"vehiclelng": "112.963848",
       			"vehiclelat": "28.052736",
       			"vehicleheight": "41",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "159212.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225458",
       			"todaymileage": "448.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "612",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "æ¹K15926D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFXAH76W7R3002339",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174064894469.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174064939266.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382211313",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169655545596.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "è´§è¿",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "æ¹KA659æ",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1724461638",
       			"operateuid": "189635",
       			"operateuname": "å½­è°¨âéå¬åº",
       			"thingid": "854",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "æªåç»çµå¨éå¡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K15926D",
       			"thingregnum": "15926",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "41619674940",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002339",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473619,
       			"maplng": 113.510927,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505616",
       			"vehiclelat": "23.476225",
       			"vehicleheight": "25",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "20570.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225053",
       			"todaymileage": "370.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "613",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "306210",
       			"username": "192****4657",
       			"licenseplatenumber": "æ¹K15982D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFXAH76W6R3002719",
       			"licensemainimage": "tgjffwl/khy/2024/08/28/aafc01e48217ac2e6c58f1320e004406.jpg",
       			"licensesideimage": "tgjffwl/khy/2024/08/28/33930615b260763e99f6a3e5ff05ec1e.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382211301",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/khy/2024/08/28/5a7542b1b849c91d90e822ab81e22656.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "è´§è¿",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "æ¹KV805æ",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/2729fb3f3c92e0f756e9513e81bb8e01.jpg",
       			"truckaxles": "6è½´",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724828039",
       			"dateline": "1714033732",
       			"modifytime": "1725638461",
       			"operateuid": "306210",
       			"operateuname": "192****4657",
       			"thingid": "832",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "èå´åµ",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K15982D",
       			"thingregnum": "15982",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "41619674933",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002719",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766359,
       			"maplng": 111.981089,
       			"mapaddr": null,
       			"staffname": "çç¨è",
       			"staffmobile": "19237384657",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "20",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "è´§è¿å¸æºå·²å®å·¥",
       			"vehiclelng": "111.975625",
       			"vehiclelat": "27.769736",
       			"vehicleheight": "136",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "38570.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225127",
       			"todaymileage": "332.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "380",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "307443",
       			"username": "19374524020",
       			"licenseplatenumber": "æ¹K15996D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFCAH96W9N3003550",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/3e9f987187a12fe2707a608b2c718665.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/66f6ce1216d4c0407e742e59e286ccc7.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382209723",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/be6de2552e11920187599a3271a210e4.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/6afbcffb3fca8915b0cf0ea3d6f6bf7b.jpg",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "è´§è¿",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "æ¹KG222æ",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/4cc371e51506a9a3da93fbe802679ddc.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1724975016",
       			"operateuid": "307443",
       			"operateuname": "19374524020",
       			"thingid": "380",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "è§å»ºæ¥",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K15996D",
       			"thingregnum": "15996",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "64846225659",
       			"outcardno": "0000003772835737",
       			"thingvin": "LFCAH96W9N3003550",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.745639,
       			"maplng": 112.106531,
       			"mapaddr": null,
       			"staffname": "19374524020",
       			"staffmobile": "19374524020",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "å·²å°è¾¾å®æå¸è´§",
       			"vehiclelng": "112.100803",
       			"vehiclelat": "27.748755",
       			"vehicleheight": "98",
       			"vehiclespeed": "55.40",
       			"vehicledirection": "272",
       			"vehiclemileage": "149876.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "290.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "614",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "307077",
       			"username": "152****2836",
       			"licenseplatenumber": "æ¹K16206D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFXAH76W1R3002711",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/c8ceab41a7f866eb83aa5c81b9b9f411.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/275a06ae5cd5222a57ad0be251371673.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-22",
       			"licenseregisterdate": "2024-04-22",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382211292",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/0439f4a297403074de4098d2b7c6fbcd.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "è´§è¿",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "æ¹KF288æ",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0a96c227ee61349fc5cff50708af78ce.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1725695085",
       			"dateline": "1714033732",
       			"modifytime": "1725711831",
       			"operateuid": "307077",
       			"operateuname": "152****2836",
       			"thingid": "855",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "ä¸æ",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K16206D",
       			"thingregnum": "16206",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "41619674913",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002711",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910029,
       			"maplng": 111.857693,
       			"mapaddr": null,
       			"staffname": "å´æè¯",
       			"staffmobile": "15273822836",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "è´§è¿å¸æºå·²å®å·¥",
       			"vehiclelng": "111.852277",
       			"vehiclelat": "27.913497",
       			"vehicleheight": "177",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "110",
       			"vehiclemileage": "18182.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225500",
       			"todaymileage": "530.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "381",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "è´§æ»¡æ»¡",
       			"userid": "299392",
       			"username": "å¼ äºå",
       			"licenseplatenumber": "æ¹K16209D",
       			"truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"identifycode": "LFCAH96W2N3003521",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/dbb8ab391cd007ee19469e2213f3c0bc.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9a438aa00ea479a094356679a46f1628.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
       			"roadtransportnumber": "431382209660",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/72f2cbfa39b3a2ab7c60dece3e3d98b0.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/c3350be1e31d2744a8fde694468b496f.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "è´§è¿",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "æ¹KW698æ",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/7938e881601172886a580590030c731b.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725695829",
       			"operateuid": "299392",
       			"operateuname": "éå¬åº",
       			"thingid": "381",
       			"thingname": "ä¸ä¸",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "è§å»ºæ¥",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "æ¹K16209D",
       			"thingregnum": "16209",
       			"thingpower": "2",
       			"thingcat": "éååæçµå¼è½¦",
       			"vehiclecode": "64846257030",
       			"outcardno": "0000001627353497",
       			"thingvin": "LFCAH96W2N3003521",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049074,
       			"maplng": 112.970567,
       			"mapaddr": null,
       			"staffname": "张亚军",
       			"staffmobile": "13347238997",
       			"taskid": "0",
       			"tasknum": "224",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "112.965060",
       			"vehiclelat": "28.052513",
       			"vehicleheight": "25",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "167839.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225209",
       			"todaymileage": "342.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "713",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307057",
       			"username": "13874818956",
       			"licenseplatenumber": "湘K16212D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002588",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b9a2da590eebb972f585a8881646f729.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/535b2cc23d46dfc4d8f998730d0805b9.jpg",
       			"licenseexpiredate": "2039-05-21",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "2024-05-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211477",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/fab3018a68530522e085eeff346ba75c.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2027-05-26",
       			"trucktypecode": "Q11",
       			"platecolor": "93",
       			"energytype": "C",
       			"registerdate": null,
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KN615挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/d87332abcf0afdeac5655ddd0d251856.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1725696450",
       			"dateline": "1716969695",
       			"modifytime": "1725703536",
       			"operateuid": "274028",
       			"operateuname": "19911534004",
       			"thingid": "891",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16212D",
       			"thingregnum": "16212",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906986",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002588",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910167,
       			"maplng": 111.857793,
       			"mapaddr": null,
       			"staffname": "王琛",
       			"staffmobile": "13874818956",
       			"taskid": "22090",
       			"tasknum": "221",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.852377",
       			"vehiclelat": "27.913636",
       			"vehicleheight": "177",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "25126.1",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225507",
       			"todaymileage": "354.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "615",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K16226D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002353",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174065534633.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174065578214.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211239",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169657348959.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KN908挂",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1724405254",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "841",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16226D",
       			"thingregnum": "16226",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674917",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002353",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473763,
       			"maplng": 113.510899,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505588",
       			"vehiclelat": "23.476369",
       			"vehicleheight": "11",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "24283.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225228",
       			"todaymileage": "370.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "0",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": null,
       			"truckowner": null,
       			"identifycode": null,
       			"licensemainimage": null,
       			"licensesideimage": null,
       			"licenseexpiredate": null,
       			"licenseissuedate": null,
       			"licenseregisterdate": null,
       			"licenseissueorgname": null,
       			"roadtransportnumber": null,
       			"roadtransportpermitno": null,
       			"transportlicensemain": null,
       			"transportlicenseside": null,
       			"transportvalidenddate": null,
       			"trucktypecode": null,
       			"platecolor": null,
       			"energytype": null,
       			"registerdate": null,
       			"inspectionenddate": null,
       			"usenature": null,
       			"loadweight": null,
       			"loadlength": null,
       			"totalweight": null,
       			"curbweight": null,
       			"outlinelength": null,
       			"outlinewidth": null,
       			"outlineheight": null,
       			"trailerplatenumber": null,
       			"trailertypecode": null,
       			"trailerloadweight": null,
       			"businessholdsname": null,
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": null,
       			"syncstatus": null,
       			"auditstatus": null,
       			"auditmsg": null,
       			"audittime": null,
       			"dateline": "1716970585",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "896",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": null,
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16255D",
       			"thingregnum": "16255",
       			"thingpower": "2",
       			"thingcat": null,
       			"vehiclecode": "42055906981",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "40.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.371784,
       			"maplng": 113.330176,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.324736",
       			"vehiclelat": "23.374300",
       			"vehicleheight": "3",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "8615.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "330.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "428",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307373",
       			"username": "易朝辉",
       			"licenseplatenumber": "湘K16256D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W2N3002837",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/bb3f6674c0adc57c1f33ccbc4cbeb228.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/853355c18c051afb269068340fa04728.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209667",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/f4607cb8b4381ae59fe61fe92c0f417b.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/47f86b6481766845e7d6cb0541c71c92.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KB958挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1680248055",
       			"modifytime": "1725702513",
       			"operateuid": "307373",
       			"operateuname": "18873899610",
       			"thingid": "428",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16256D",
       			"thingregnum": "16256",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40818676304",
       			"outcardno": "",
       			"thingvin": "LFCAH96W2N3002837",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775387,
       			"maplng": 111.697209,
       			"mapaddr": null,
       			"staffname": "易朝辉",
       			"staffmobile": "18873899610",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691713",
       			"vehiclelat": "27.778755",
       			"vehicleheight": "174",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "46433.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224845",
       			"todaymileage": "480.0",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "523",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307038",
       			"username": "17373225752",
       			"licenseplatenumber": "湘K16259D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W6N3003554",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/3d77846cd8c33261196d78b5524d1ea8.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/f0bebc1878af88eb0bb8612e27668208.jpg",
       			"licenseexpiredate": "2037-12-30",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209674",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/62365cdc5d2384ee53f73d7f18ceec79.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/0febfd9b75c0bb04d05b0d47c936df0a.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "25470",
       			"loadlength": "0.00",
       			"totalweight": "37170",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KD323挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "3400",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/92d6adf52fc0262a7de82a58aae2e482.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725692667",
       			"operateuid": "205444",
       			"operateuname": "Loong",
       			"thingid": "382",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16259D",
       			"thingregnum": "16259",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846331380",
       			"outcardno": "",
       			"thingvin": "LFCAH96W6N3003554",
       			"trailercode": null,
       			"thington": "37.100",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766363,
       			"maplng": 111.980992,
       			"mapaddr": null,
       			"staffname": "谭树",
       			"staffmobile": "17373225752",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975528",
       			"vehiclelat": "27.769740",
       			"vehicleheight": "148",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "147384.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224943",
       			"todaymileage": "285.3",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "628",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307109",
       			"username": "137****8728",
       			"licenseplatenumber": "湘K16265D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002679",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/933fd3b41ce17cdd511a68048eae6731.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b02e457e0c1ab04556ecf3f0687bf549.jpg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211290",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/bbf22b819e810c382c8dcacd8ca8a646.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2025-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KA192挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/e6bb099df7a4661d87d4b9fd44877d9b.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725717021",
       			"operateuid": "307109",
       			"operateuname": "137****8728",
       			"thingid": "860",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16265D",
       			"thingregnum": "16265",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674903",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002679",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.234634,
       			"maplng": 112.541459,
       			"mapaddr": null,
       			"staffname": "137****8728",
       			"staffmobile": "13787118728",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.536050",
       			"vehiclelat": "28.238094",
       			"vehicleheight": "60",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "26121.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225100",
       			"todaymileage": "506.5",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "616",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307110",
       			"username": "180****0850",
       			"licenseplatenumber": "湘K16276D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W4R3002573",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a3ca95e08d25cf19e08210365f4ee955.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/e9c80c74ec7fc8230d384502833e9972.jpg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "娄底公安局",
       			"roadtransportnumber": "431382211280",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/3d59751b677442c8318db02d2c3f7cd3.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/1ac8abfa6309daf3e11350e779bab60d.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "1",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KP852挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "瑞麟物流",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/ab9c3fb5b64525059133966c6e600c93.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "3",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1725714884",
       			"operateuid": "307110",
       			"operateuname": "180****0850",
       			"thingid": "793",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16276D",
       			"thingregnum": "16276",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674936",
       			"outcardno": "",
       			"thingvin": "LFXAH76W4R3002573",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910357,
       			"maplng": 111.857458,
       			"mapaddr": null,
       			"staffname": "彭余辉",
       			"staffmobile": "18073360850",
       			"taskid": "22092",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.852041",
       			"vehiclelat": "27.913825",
       			"vehicleheight": "175",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "19331.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225252",
       			"todaymileage": "383.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "617",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306070",
       			"username": "191****6888",
       			"licenseplatenumber": "湘K16282D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002669",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/683d645e45442557367fd0a8d01c5fb4.jpeg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2025-04-16",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211258",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/cbc36410aed5ce526acdb5255c1d4c39.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/f599187e3a122a62b5fe9778b617367d.jpeg",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KF592挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/be3702b6802946c9be159a11f0f74838.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725717213",
       			"operateuid": "306070",
       			"operateuname": "191****6888",
       			"thingid": "776",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16282D",
       			"thingregnum": "16282",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906995",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002669",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970716,
       			"maplng": 111.90821,
       			"mapaddr": null,
       			"staffname": "191****6888",
       			"staffmobile": "19118546888",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902847",
       			"vehiclelat": "27.974241",
       			"vehicleheight": "261",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "31",
       			"vehiclemileage": "41621.9",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225500",
       			"todaymileage": "502.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "383",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305730",
       			"username": "吴交均",
       			"licenseplatenumber": "湘K16296D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3003557",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ff3ac049fd5ae8b2357d46b27645a609.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9e9c8307527279b7b3ad67f1b1a983df.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209661",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/ea64b70d19e79a0cb9b55066ac4faab7.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/84e4e9e97816ae7f32b5162574313f04.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘K9207挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725715182",
       			"operateuid": "305730",
       			"operateuname": "173****2219",
       			"thingid": "383",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16296D",
       			"thingregnum": "16296",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846210366",
       			"outcardno": "000000000160860",
       			"thingvin": "LFCAH96W1N3003557",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766398,
       			"maplng": 111.981188,
       			"mapaddr": null,
       			"staffname": "吴交均",
       			"staffmobile": "17397382219",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975723",
       			"vehiclelat": "27.769775",
       			"vehicleheight": "154",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "153818.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224836",
       			"todaymileage": "234.3",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "618",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K16306D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002350",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a98e38a19b0e4af4e8703fcc740d5743.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/24f9a53f9ca091ac408cd586a5653838.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211277",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/701f7a640f4e02fbdc7afa51e349e20b.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KJ335挂",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1724402101",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "777",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16306D",
       			"thingregnum": "16306",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674930",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002350",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.47368,
       			"maplng": 113.510944,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505633",
       			"vehiclelat": "23.476286",
       			"vehicleheight": "11",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "25387.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225041",
       			"todaymileage": "370.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "619",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307086",
       			"username": "180****6958",
       			"licenseplatenumber": "湘K16379D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LA9964E30R0HSN042",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/c37d417676a33095648c32ff4adfd137.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/0632c8c29c3a1fc7fd4a51c845a6cfe6.jpg",
       			"licenseexpiredate": "2039-04-18",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211247",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/c918079913364e3d28447a7a595523e3.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/c918079913364e3d28447a7a595523e3.jpg",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "500",
       			"outlinewidth": "2550",
       			"outlineheight": "3500",
       			"trailerplatenumber": "湘K5601挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/79850d9512777bfb5988e711ec83b5bb.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725708903",
       			"operateuid": "307086",
       			"operateuname": "180****6958",
       			"thingid": "842",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16379D",
       			"thingregnum": "16379",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906994",
       			"outcardno": "",
       			"thingvin": "LA9964E30R0HSN042",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048457,
       			"maplng": 112.971058,
       			"mapaddr": null,
       			"staffname": "180****6958",
       			"staffmobile": "18073286958",
       			"taskid": "0",
       			"tasknum": "221",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965550",
       			"vehiclelat": "28.051894",
       			"vehicleheight": "56",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "154",
       			"vehiclemileage": "38358.1",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225502",
       			"todaymileage": "452.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "384",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "301228",
       			"username": "131****0050",
       			"licenseplatenumber": "湘K16579D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3002831",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/cd490e602a092f9a2faa2c4f908bed35.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/9b0ed7a3392d9759d205499af071bc2d.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209716",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/e28a419cc2d28ee51d388105b8901dd2.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/04306002984bab34b541c7a2ee6d3a9e.jpg",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KA183挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725706891",
       			"operateuid": "301228",
       			"operateuname": "131****0050",
       			"thingid": "384",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16579D",
       			"thingregnum": "16579",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846246722",
       			"outcardno": "0000002965114266",
       			"thingvin": "LFCAH96W1N3002831",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049223,
       			"maplng": 112.969288,
       			"mapaddr": null,
       			"staffname": "131****0050",
       			"staffmobile": "13135330050",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.963785",
       			"vehiclelat": "28.052665",
       			"vehicleheight": "57",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "161047.6",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224647",
       			"todaymileage": "401.9",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "620",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "278918",
       			"username": "毛申军",
       			"licenseplatenumber": "湘K16638D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3000388",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/380a371e6f71b4482d921b13ec13c339.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/91413ace847b23868c8d2a6ad447992d.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211267",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/cca95dfa5f6622fa5d01506777cdd6f7.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/c371d1bc75dfd42e7e975d7105d6c26e.jpeg",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KK091挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/135e5e8bcc988d7b61139bd9f67e9efe.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725716201",
       			"operateuid": "278918",
       			"operateuname": "毛申军",
       			"thingid": "778",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16638D",
       			"thingregnum": "16638",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906999",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3000388",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970638,
       			"maplng": 111.908265,
       			"mapaddr": null,
       			"staffname": "毛申军",
       			"staffmobile": "15386285316",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902902",
       			"vehiclelat": "27.974163",
       			"vehicleheight": "260",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "46",
       			"vehiclemileage": "34653.8",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225503",
       			"todaymileage": "512.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "621",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299397",
       			"username": null,
       			"licenseplatenumber": "湘K16728D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002675",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/56d20fe7cd6c9ee7a3df5b773e1ace6d.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/d7bbc94fb5db1391a4d8edd3407412d3.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211234",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/98c69a965967066bc84ca4c53541a4e3.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KE838挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725695800",
       			"operateuid": "299397",
       			"operateuname": "13278869115",
       			"thingid": "794",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16728D",
       			"thingregnum": "16728",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674908",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002675",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910218,
       			"maplng": 111.857411,
       			"mapaddr": null,
       			"staffname": "廖建红",
       			"staffmobile": "13278869115",
       			"taskid": "0",
       			"tasknum": "237",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.851994",
       			"vehiclelat": "27.913686",
       			"vehicleheight": "172",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "19535.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225203",
       			"todaymileage": "354.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "683",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307079",
       			"username": "134****0805",
       			"licenseplatenumber": "湘K16758D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W3R3002600",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4d57d8d1ed2d2f1c22e3e17838701646.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/8be6a7cc5307a2b73a309afad7faa654.jpg",
       			"licenseexpiredate": "2039-05-24",
       			"licenseissuedate": "2024-05-24",
       			"licenseregisterdate": "2024-05-24",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211500",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/dece5bc16655e9bc10f29a9fa8899233.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-05-28",
       			"trucktypecode": "Q11",
       			"platecolor": "93",
       			"energytype": "C",
       			"registerdate": "2024-05-31",
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KC379挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/c894f67c25832e1a14c1c40c6c52e63e.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"validEndDate\",\"remarks\":\"运输证有效期有误\",\"result\":1}]",
       			"audittime": "1725520890",
       			"dateline": "1716970840",
       			"modifytime": "1725694534",
       			"operateuid": "307079",
       			"operateuname": "134****0805",
       			"thingid": "899",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "10",
       			"thingteam": "七星",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16758D",
       			"thingregnum": "16758",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906979",
       			"outcardno": "",
       			"thingvin": "LFXAH76W3R3002600",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.910023,
       			"maplng": 111.857633,
       			"mapaddr": null,
       			"staffname": "134****0805",
       			"staffmobile": "13413210805",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.852216",
       			"vehiclelat": "27.913491",
       			"vehicleheight": "168",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "21048.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225114",
       			"todaymileage": "354.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "622",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307172",
       			"username": "15675870185",
       			"licenseplatenumber": "湘K16787D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002599",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/f95bfb994ad1f05be2980cff85859b35.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/44b25940ee0510861053d0e8df6d6bd2.jpeg",
       			"licenseexpiredate": "2039-04-17",
       			"licenseissuedate": "2024-04-17",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211260",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/28e2de0f670a0274688d20165a83e9c5.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/c8fd2ad24bde4cd5529db98b0dbe822b.jpeg",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KD161挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/7b095cf789605d65eb22c00767b8fc8f.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838528",
       			"dateline": "1713764524",
       			"modifytime": "1725717382",
       			"operateuid": "307172",
       			"operateuname": "15675870185",
       			"thingid": "779",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16787D",
       			"thingregnum": "16787",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906997",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002599",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.766389,
       			"maplng": 111.981008,
       			"mapaddr": null,
       			"staffname": "吴胜财",
       			"staffmobile": "15675870185",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975544",
       			"vehiclelat": "27.769766",
       			"vehicleheight": "134",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "36356.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225136",
       			"todaymileage": "334.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "623",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307196",
       			"username": "172****0182",
       			"licenseplatenumber": "湘K16805D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002670",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/73cb070bd7a82e84ba140ebca65a3c81.jpeg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211233",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/e5b8db19f09f9f2bd548a3d1930c5517.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-23",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KT826挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/bf52a80fb6a184493df0281c9543ef2e.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724838098",
       			"dateline": "1713764524",
       			"modifytime": "1725717510",
       			"operateuid": "307196",
       			"operateuname": "淡淡的微笑",
       			"thingid": "795",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16805D",
       			"thingregnum": "16805",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357301",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002670",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765675,
       			"maplng": 111.981183,
       			"mapaddr": null,
       			"staffname": "何姿良",
       			"staffmobile": "17267840182",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.975719",
       			"vehiclelat": "27.769052",
       			"vehicleheight": "131",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "32561.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225327",
       			"todaymileage": "343.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "630",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307094",
       			"username": "187****7003",
       			"licenseplatenumber": "湘K16856D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W6R3002672",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/cf82ef3002d507c2416f2be018df2c8d.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211302",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/6eec01a26805bf665b46fdac44f55931.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/6eec01a26805bf665b46fdac44f55931.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KP011挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/ef6bdfac8fd8aed46f8517a204a97f2a.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725713188",
       			"operateuid": "307094",
       			"operateuname": "18773827003",
       			"thingid": "861",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16856D",
       			"thingregnum": "16856",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674902",
       			"outcardno": "",
       			"thingvin": "LFXAH76W6R3002672",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765828,
       			"maplng": 111.980955,
       			"mapaddr": null,
       			"staffname": "187****7003",
       			"staffmobile": "18773827003",
       			"taskid": "0",
       			"tasknum": "238",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975491",
       			"vehiclelat": "27.769205",
       			"vehicleheight": "117",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "31780.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225408",
       			"todaymileage": "120.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "636",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307165",
       			"username": "18627616789",
       			"licenseplatenumber": "湘K16926D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002188",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b39c2784f9097dcbc317fe1df0a58f0c.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2039-04-02",
       			"licenseissuedate": "2024-04-02",
       			"licenseregisterdate": "2024-04-02",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211111",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/f3e3551e5343d7d8801c1302108af055.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/166db3285465a681d15c2ea04da0abd6.jpeg",
       			"transportvalidenddate": "2027-04-09",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KH605挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/49c1bc12726c195045973aa69eb5604c.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724839026",
       			"dateline": "1713764524",
       			"modifytime": "1725679483",
       			"operateuid": "307165",
       			"operateuname": "18627616789",
       			"thingid": "758",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16926D",
       			"thingregnum": "16926",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906970",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002188",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776074,
       			"maplng": 111.696155,
       			"mapaddr": null,
       			"staffname": "吴琼",
       			"staffmobile": "18627616789",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690661",
       			"vehiclelat": "27.779444",
       			"vehicleheight": "177",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "38212.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225354",
       			"todaymileage": "342.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "635",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306052",
       			"username": "180****2832",
       			"licenseplatenumber": "湘K16999D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002178",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/7fb0484b3e307e6d47446201f408a861.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/e4887b76c8a1944cbcaa1df485b82943.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211137",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/5a2ee7567580dcd8623e7d879ac17fb5.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/c50e73f61d5d8aa0979fe1d690ac53d7.jpeg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K8508挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/0b79e667eae2c75c9fa3c9aa27385a92.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725671470",
       			"operateuid": "306052",
       			"operateuname": "18075922832",
       			"thingid": "767",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K16999D",
       			"thingregnum": "16999",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357348",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002178",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776121,
       			"maplng": 111.696163,
       			"mapaddr": null,
       			"staffname": "180****2832",
       			"staffmobile": "18075922832",
       			"taskid": "0",
       			"tasknum": "221",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690669",
       			"vehiclelat": "27.779491",
       			"vehicleheight": "184",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "109",
       			"vehiclemileage": "45321.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225453",
       			"todaymileage": "351.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "624",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306104",
       			"username": "181****8855",
       			"licenseplatenumber": "湘K17086D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W1R3002577",
       			"licensemainimage": "tgj168/image/2024/06/03/132846_17174058179298.jpg",
       			"licensesideimage": "tgj168/image/2024/06/03/132846_17174058215260.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211254",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169509685989.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K5159挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a503af9a533638da22871a49766714a6.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725674997",
       			"operateuid": "306104",
       			"operateuname": "18152788855",
       			"thingid": "796",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K17086D",
       			"thingregnum": "17086",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808357302",
       			"outcardno": "",
       			"thingvin": "LFXAH76W1R3002577",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765814,
       			"maplng": 111.981169,
       			"mapaddr": null,
       			"staffname": "181****8855",
       			"staffmobile": "18152788855",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975705",
       			"vehiclelat": "27.769191",
       			"vehicleheight": "137",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "37294.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225138",
       			"todaymileage": "335.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "385",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300171",
       			"username": "周裔庄",
       			"licenseplatenumber": "湘K17226D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W6N3003585",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/d3e8b51f3fed6ac7526c1b1c1f63f22d.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/fde37392c96fba9ec33663bd829beb29.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209670",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/703a28486e917ded45b4786f4e2afb24.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/04c373f360ed0605928e4a1f0c67d439.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KJ306挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725633927",
       			"operateuid": "300171",
       			"operateuname": "183****6080",
       			"thingid": "385",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K17226D",
       			"thingregnum": "17226",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846215569",
       			"outcardno": "0000001347931545",
       			"thingvin": "LFCAH96W6N3003585",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775527,
       			"maplng": 111.697136,
       			"mapaddr": null,
       			"staffname": "周裔庄",
       			"staffmobile": "18373856080",
       			"taskid": "0",
       			"tasknum": "235",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691640",
       			"vehiclelat": "27.778895",
       			"vehicleheight": "183",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "182249.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225306",
       			"todaymileage": "468.0",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "633",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306660",
       			"username": "18173705191",
       			"licenseplatenumber": "湘K17228D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002183",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/f71e35b6bd98f2c63457552cdd45f459.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/186d9eb07fdfa916d81e087ce251dba2.jpeg",
       			"licenseexpiredate": "2025-04-01",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211130",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/5d12dc96caa47220838ecd97fffec7ab.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/2b8087b1504def4133aa4ce71b35e4d4.jpeg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KR897挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/cf537ba458083d11263b142cf27ce96d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725671443",
       			"operateuid": "306660",
       			"operateuname": "18173705191",
       			"thingid": "768",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K17228D",
       			"thingregnum": "17228",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40808356961",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002183",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.776141,
       			"maplng": 111.696194,
       			"mapaddr": null,
       			"staffname": "18173705191",
       			"staffmobile": "18173705191",
       			"taskid": "0",
       			"tasknum": "232",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690700",
       			"vehiclelat": "27.779511",
       			"vehicleheight": "183",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "111",
       			"vehiclemileage": "44688.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225501",
       			"todaymileage": "326.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "707",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307119",
       			"username": "159****5788",
       			"licenseplatenumber": "湘K17996D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76WXR3002691",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/552b11df00f235ac5644959b8d725e84.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/aa4cf598a31fc38caa31b0fd6bcde3fb.jpg",
       			"licenseexpiredate": "2025-05-20",
       			"licenseissuedate": "2024-05-21",
       			"licenseregisterdate": "2024-05-21",
       			"licenseissueorgname": "湖南省娄底市公安交通警察支队",
       			"roadtransportnumber": "431382211478",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/5e8389816fcd9f984baa188a5c681ed3.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/5e8389816fcd9f984baa188a5c681ed3.jpg",
       			"transportvalidenddate": "2027-05-26",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KH959挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/2b7faa67f452183ce607a9552df63831.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969741",
       			"modifytime": "1725631985",
       			"operateuid": "307119",
       			"operateuname": "159****5788",
       			"thingid": "893",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K17996D",
       			"thingregnum": "17996",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906989",
       			"outcardno": "",
       			"thingvin": "LFXAH76WXR3002691",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.708533,
       			"maplng": 112.345198,
       			"mapaddr": null,
       			"staffname": "159****5788",
       			"staffmobile": "15973835788",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "112.339586",
       			"vehiclelat": "27.711711",
       			"vehicleheight": "67",
       			"vehiclespeed": "48.00",
       			"vehicledirection": "224",
       			"vehiclemileage": "24444.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225456",
       			"todaymileage": "262.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "386",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305731",
       			"username": "177****7116",
       			"licenseplatenumber": "湘K17998D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W4N3003584",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/146c444bcaa762bb24e031c73e37b8f3.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/279320b8d478910287d81c8e3e7b8b93.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209638",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/ddf3b412bce78f395d1d08d1ac95e82e.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/07de8ada691f741eed5dc5ba4bed7d2d.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KC106挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6cdc3f1042d265e035ecfdbe8a0252a4.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725718479",
       			"operateuid": "305731",
       			"operateuname": "177****7116",
       			"thingid": "386",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K17998D",
       			"thingregnum": "17998",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846230375",
       			"outcardno": "0000001883630489",
       			"thingvin": "LFCAH96W4N3003584",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048632,
       			"maplng": 112.970924,
       			"mapaddr": null,
       			"staffname": "177****7116",
       			"staffmobile": "17775157116",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965416",
       			"vehiclelat": "28.052070",
       			"vehicleheight": "39",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "163457.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225443",
       			"todaymileage": "484.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "632",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307150",
       			"username": "183****3601",
       			"licenseplatenumber": "湘K18002D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002583",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/720187f6999b96a3eed0cf037d46bc42.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/a487b408a800171c92366138c92e5fe8.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211303",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/749435f16a8a2b7d4e7eff85287d1234.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-30",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KQ680挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a2ebe1dff0dfc4d7cc0ab4fea13d929e.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724828631",
       			"dateline": "1714033732",
       			"modifytime": "1725682872",
       			"operateuid": "307150",
       			"operateuname": "183****3601",
       			"thingid": "862",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18002D",
       			"thingregnum": "18002",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674926",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002583",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765627,
       			"maplng": 111.980776,
       			"mapaddr": null,
       			"staffname": "谌荣国",
       			"staffmobile": "18390623601",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975313",
       			"vehiclelat": "27.769005",
       			"vehicleheight": "133",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "28329.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "335.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "387",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299629",
       			"username": "189****8766",
       			"licenseplatenumber": "湘K18017D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003548",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/5b6632621bbef936d390377c206d215b.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/3b4809d2a0b6e05273d6463380e57591.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209640",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/022d3e833fd8edea6295c5fa9cd18954.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/d4265e5f815c4161a46d4342f549887f.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KL963挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/b4558d83dd96a36fac96ddf442faf955.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725698812",
       			"operateuid": "299629",
       			"operateuname": "189****8766",
       			"thingid": "387",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18017D",
       			"thingregnum": "18017",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846220128",
       			"outcardno": "0000000547868057",
       			"thingvin": "LFCAH96W0N3003548",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775803,
       			"maplng": 111.697159,
       			"mapaddr": null,
       			"staffname": "189****8766",
       			"staffmobile": "18973898766",
       			"taskid": "0",
       			"tasknum": "231",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691663",
       			"vehiclelat": "27.779171",
       			"vehicleheight": "159",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "157914.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225346",
       			"todaymileage": "263.4",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "634",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307189",
       			"username": "17742587591",
       			"licenseplatenumber": "湘K18026D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002152",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e7840505d15b29ab50fb4a8f2fc99691.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/80455f9de9e9457f957c9686e01bb6e8.jpeg",
       			"licenseexpiredate": "2025-04-08",
       			"licenseissuedate": "2024-04-09",
       			"licenseregisterdate": "2024-04-09",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211135",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/3dceba5549d92bfd53ca3b6bae38e075.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/0cb1fdf8d08de3463fcc5d298c0182f8.jpeg",
       			"transportvalidenddate": "2027-04-10",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-24",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KU015挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/d62a91d6c554d59b3d48bd8eed556ceb.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1713764524",
       			"modifytime": "1725692203",
       			"operateuid": "307189",
       			"operateuname": "17742587591",
       			"thingid": "769",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18026D",
       			"thingregnum": "18026",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906969",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002152",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.77608,
       			"maplng": 111.696163,
       			"mapaddr": null,
       			"staffname": "17742587591",
       			"staffmobile": "17742587591",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.690669",
       			"vehiclelat": "27.779450",
       			"vehicleheight": "168",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "33138.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225023",
       			"todaymileage": "345.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "388",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305732",
       			"username": "189****",
       			"licenseplatenumber": "湘K18029D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W6N3002615",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/e5d513ac9f317b79e6d6f9d2287c4128.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/b5ecc6d2df9eddd6bfa471a0ce84c1b3.jpg",
       			"licenseexpiredate": "2024-12-26",
       			"licenseissuedate": "2022-12-27",
       			"licenseregisterdate": "2022-12-27",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209651",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/229153cd83b8a369c5674ad10aae5669.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/622ebc2eeb610e9ed9947c5970bf6fde.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-27",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KV016挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/da34061c3be0520d716f726ba4db65d0.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724811902",
       			"dateline": "1678693585",
       			"modifytime": "1725711035",
       			"operateuid": "305732",
       			"operateuname": "189****",
       			"thingid": "388",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18029D",
       			"thingregnum": "18029",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846233319",
       			"outcardno": "00000024224610",
       			"thingvin": "LFCAH96W6N3002615",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.04848,
       			"maplng": 112.970971,
       			"mapaddr": null,
       			"staffname": "熊望",
       			"staffmobile": "18973146712",
       			"taskid": "0",
       			"tasknum": "217",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965463",
       			"vehiclelat": "28.051918",
       			"vehicleheight": "43",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "145821.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225500",
       			"todaymileage": "486.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "581",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307118",
       			"username": "180****9262",
       			"licenseplatenumber": "湘K18038D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002570",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/0ce243ba088e9d5f049dd8ef14f68e45.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/de9ccad6d3e775e814856942f6c38930.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211300",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/5eb2ab844629dbdb48fe62622cf5eb3c.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KU535挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/a9decd5d35bdbfafd992ef3d0d6bfe7d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1714033732",
       			"modifytime": "1725713124",
       			"operateuid": "307118",
       			"operateuname": "18075679262",
       			"thingid": "833",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18038D",
       			"thingregnum": "18038",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674900",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002570",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.765725,
       			"maplng": 111.980925,
       			"mapaddr": null,
       			"staffname": "180****9262",
       			"staffmobile": "18075679262",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975461",
       			"vehiclelat": "27.769102",
       			"vehicleheight": "140",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "343",
       			"vehiclemileage": "34693.5",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225505",
       			"todaymileage": "334.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "688",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K18055D",
       			"truckowner": "",
       			"identifycode": "",
       			"licensemainimage": "",
       			"licensesideimage": "",
       			"licenseexpiredate": "",
       			"licenseissuedate": "",
       			"licenseregisterdate": "",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211144",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/06/04/189635_17174871164770.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": null,
       			"trucktypecode": "",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": null,
       			"usenature": "",
       			"loadweight": "0",
       			"loadlength": "0.00",
       			"totalweight": "0",
       			"curbweight": null,
       			"outlinelength": "0",
       			"outlinewidth": "0",
       			"outlineheight": "0",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1720427336",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "759",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18055D",
       			"thingregnum": "18055",
       			"thingpower": "2",
       			"thingcat": "牵引车",
       			"vehiclecode": "40808356958",
       			"outcardno": "",
       			"thingvin": "",
       			"trailercode": null,
       			"thington": "0.000",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473943,
       			"maplng": 113.511072,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505761",
       			"vehiclelat": "23.476550",
       			"vehicleheight": "23",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "31839.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225122",
       			"todaymileage": "0.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "625",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307075",
       			"username": null,
       			"licenseplatenumber": "湘K18056D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002572",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/6f1b481655bb35de912f88125292aec9.jpeg",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211297",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/1690e3433ca1397d2b6a688270a41b4c.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KR990挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/81939d3a7d01b62915e64895670e3443.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724810673",
       			"dateline": "1713764524",
       			"modifytime": "1725713215",
       			"operateuid": "307075",
       			"operateuname": "151****9878",
       			"thingid": "797",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18056D",
       			"thingregnum": "18056",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674929",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002572",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.16174,
       			"maplng": 112.665047,
       			"mapaddr": null,
       			"staffname": "李海波",
       			"staffmobile": "15115689878",
       			"taskid": "22087",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "112.659641",
       			"vehiclelat": "28.165211",
       			"vehicleheight": "79",
       			"vehiclespeed": "84.00",
       			"vehicledirection": "135",
       			"vehiclemileage": "33891.3",
       			"vehiclewarn": "262144",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225340",
       			"todaymileage": "514.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "626",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "0",
       			"username": null,
       			"licenseplatenumber": "湘K18065D",
       			"truckowner": "涟源瑞腾智慧物流有限公司",
       			"identifycode": "LFXAH76W9R3002598",
       			"licensemainimage": "tgj168/image/2024/06/04/189635_17174852276001.jpg",
       			"licensesideimage": "",
       			"licenseexpiredate": "2025-04-30",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211266",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169632801203.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-24",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "",
       			"trailertypecode": null,
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞腾智慧物流有限公司",
       			"carwithownerimage": null,
       			"truckaxles": null,
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "-1",
       			"auditmsg": null,
       			"audittime": "1724746692",
       			"dateline": "1713764524",
       			"modifytime": "1724396668",
       			"operateuid": "189635",
       			"operateuname": "彭谨–铁公基",
       			"thingid": "798",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "8",
       			"thingteam": "未分组电动重卡",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞腾智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18065D",
       			"thingregnum": "18065",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674920",
       			"outcardno": "",
       			"thingvin": "LFXAH76W9R3002598",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 23.473802,
       			"maplng": 113.510894,
       			"mapaddr": null,
       			"staffname": null,
       			"staffmobile": null,
       			"taskid": "0",
       			"tasknum": "239",
       			"leavestatus": "0",
       			"thingstatus": "10",
       			"applystatus": "0",
       			"operatemsg": null,
       			"vehiclelng": "113.505583",
       			"vehiclelat": "23.476408",
       			"vehicleheight": "9",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "7986.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225236",
       			"todaymileage": "370.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "389",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300277",
       			"username": "189****7912",
       			"licenseplatenumber": "湘K18219D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W1N3003574",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/c0fea4645b324d9ce51391fd307fd6eb.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/958f27afd3f00eadca5621cbca358400.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209715",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/c351e6fcf74f80e2d6321ac9a7c4b993.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/7f1fddfc8433e8a6240304e644eb7419.jpg",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘K8288挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/594449c54a680e8794820e3d3d6d5432.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725709697",
       			"operateuid": "300277",
       			"operateuname": "189****7912",
       			"thingid": "389",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18219D",
       			"thingregnum": "18219",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846211071",
       			"outcardno": "0000000270477978",
       			"thingvin": "LFCAH96W1N3003574",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048954,
       			"maplng": 112.969491,
       			"mapaddr": null,
       			"staffname": "189****7912",
       			"staffmobile": "18974127912",
       			"taskid": "0",
       			"tasknum": "225",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "112.963988",
       			"vehiclelat": "28.052395",
       			"vehicleheight": "47",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "168592.8",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225424",
       			"todaymileage": "453.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "390",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305733",
       			"username": "17352706520",
       			"licenseplatenumber": "湘K18226D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W3N3002832",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/c2c1331c81d391a8b418739ab067430b.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/eb8abdc55cc60a3a5a5e1330816ad181.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2023-01-03",
       			"licenseregisterdate": "2022-12-27",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209719",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/94b9c759bb48883e05453971bbc84520.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/de68d396534c8f5167bc4384bc84a4a0.jpg",
       			"transportvalidenddate": "2026-04-02",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-27",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KF396挂",
       			"trailertypecode": "B11",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/4980f0ed41fd33a004922e6c83403e3b.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725693235",
       			"operateuid": "305733",
       			"operateuname": "17352706520",
       			"thingid": "390",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18226D",
       			"thingregnum": "18226",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846258162",
       			"outcardno": "0000001624688281",
       			"thingvin": "LFCAH96W3N3002832",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049201,
       			"maplng": 112.970595,
       			"mapaddr": null,
       			"staffname": "17352706520",
       			"staffmobile": "17352706520",
       			"taskid": "0",
       			"tasknum": "227",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965088",
       			"vehiclelat": "28.052640",
       			"vehicleheight": "54",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "147049.7",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224954",
       			"todaymileage": "340.8",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "705",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307039",
       			"username": "19918379888",
       			"licenseplatenumber": "湘K18680D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W2R3002717",
       			"licensemainimage": "tgjffwl/image/2024/07/khy/f60ea7a13dfea252dcbf294c1c706be9.jpg",
       			"licensesideimage": "tgjffwl/image/2024/07/khy/c7b534fcfd65183471734d5b4ad6e2b8.jpg",
       			"licenseexpiredate": "2039-05-22",
       			"licenseissuedate": "2024-05-22",
       			"licenseregisterdate": "2024-05-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211471",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/07/khy/fdcf2e7982f119ea535c7d040f0f9cda.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/07/khy/da462781698d8357d3844942a0213e4a.jpg",
       			"transportvalidenddate": "2027-05-26",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-19",
       			"inspectionenddate": "2025-05-31",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KM185挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/68fa509a7375d8a8ca81d254aa6e71b3.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1716969716",
       			"modifytime": "1725696338",
       			"operateuid": "307039",
       			"operateuname": "199****9888",
       			"thingid": "892",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18680D",
       			"thingregnum": "18680",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906982",
       			"outcardno": "",
       			"thingvin": "LFXAH76W2R3002717",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.7659,
       			"maplng": 111.980972,
       			"mapaddr": null,
       			"staffname": "19918379888",
       			"staffmobile": "19918379888",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.975508",
       			"vehiclelat": "27.769277",
       			"vehicleheight": "123",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "25226.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225148",
       			"todaymileage": "343.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "631",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307201",
       			"username": "135****2699",
       			"licenseplatenumber": "湘K18835D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W0R3002568",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/a3f74a5a5a309b125ccc2b56ec326e7e.jpg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/88f5739eb916b081eb84f0ee74d8d68e.jpg",
       			"licenseexpiredate": "2025-05-27",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-17",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211287",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/66cf4810553f055f99bf428bd99c0e30.jpeg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/0f3a88d70d02569a1cb8cddffd4c9e56.jpg",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘K6179挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/4d666ae4aad482c49c3ccd44b9855c1e.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724756433",
       			"dateline": "1714033732",
       			"modifytime": "1725612780",
       			"operateuid": "307201",
       			"operateuname": "135****2699",
       			"thingid": "863",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K18835D",
       			"thingregnum": "18835",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "41619674905",
       			"outcardno": "",
       			"thingvin": "LFXAH76W0R3002568",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.013372,
       			"maplng": 111.935009,
       			"mapaddr": null,
       			"staffname": "135****2699",
       			"staffmobile": "13574892699",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.929627",
       			"vehiclelat": "28.016886",
       			"vehicleheight": "349",
       			"vehiclespeed": "44.00",
       			"vehicledirection": "248",
       			"vehiclemileage": "33268.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225456",
       			"todaymileage": "246.3",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "391",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "293151",
       			"username": "HX",
       			"licenseplatenumber": "湘K19016D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003517",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/ad27d942a2f88c9df1b78a2839f02e3a.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/a9cd2c660b7202471aa03473dd9d521c.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-27",
       			"licenseregisterdate": "2022-12-27",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209645",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/f456fdc9e00717a1bee5264b423f9631.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/78421a91ce68abda47de4bd367971b77.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-27",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KN036挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/6b7ca3afb6fc31dec33f1fbe87038f52.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725713751",
       			"operateuid": "293151",
       			"operateuname": "HX",
       			"thingid": "391",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K19016D",
       			"thingregnum": "19016",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64821212140",
       			"outcardno": "0000000275713946",
       			"thingvin": "LFCAH96W0N3003517",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048854,
       			"maplng": 112.96978,
       			"mapaddr": null,
       			"staffname": "HX",
       			"staffmobile": "15898446788",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "【结算平台】同步卸货",
       			"vehiclelng": "112.964276",
       			"vehiclelat": "28.052295",
       			"vehicleheight": "35",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "187346.0",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225118",
       			"todaymileage": "394.8",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "627",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "306068",
       			"username": null,
       			"licenseplatenumber": "湘K19256D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFXAH76W7R3002695",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/d02bc7dcaa988128fc254fe958634636.jpeg",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/fe296bee60d6b184993b05aa57c909ab.jpeg",
       			"licenseexpiredate": "",
       			"licenseissuedate": "2024-04-18",
       			"licenseregisterdate": "2024-04-18",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382211299",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/0bd2a25352040c52099234dcf87d4b2b.jpeg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2027-04-25",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-03",
       			"inspectionenddate": "2025-04-30",
       			"usenature": "货运",
       			"loadweight": "38470",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7115",
       			"outlinewidth": "2545",
       			"outlineheight": "3150",
       			"trailerplatenumber": "湘KD578挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/5a4eded40304ade087725bd583233e4e.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724815396",
       			"dateline": "1714033732",
       			"modifytime": "1725701403",
       			"operateuid": "306068",
       			"operateuname": "151****2289",
       			"thingid": "834",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "5",
       			"thingteam": "聂崎嵘",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K19256D",
       			"thingregnum": "19256",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "42055906996",
       			"outcardno": "",
       			"thingvin": "LFXAH76W7R3002695",
       			"trailercode": null,
       			"thington": "38.470",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.970577,
       			"maplng": 111.90836,
       			"mapaddr": null,
       			"staffname": "贺泽洲",
       			"staffmobile": "15115172289",
       			"taskid": "0",
       			"tasknum": "236",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.902997",
       			"vehiclelat": "27.974102",
       			"vehicleheight": "264",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "33327.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225456",
       			"todaymileage": "510.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "392",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "299930",
       			"username": "易育强",
       			"licenseplatenumber": "湘K19369D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W2N3003518",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/4686de9ebd04b2b59ce1664b6c80edbf.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/d4b9d0d48adc0b58688bb5c31ce06c79.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209641",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/dbb368f22a0ded2a505d84686237538d.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/6e9a93066c64532c19247941562c9cf6.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KY029挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725709054",
       			"operateuid": "299930",
       			"operateuname": "186****0847",
       			"thingid": "392",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K19369D",
       			"thingregnum": "19369",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846237177",
       			"outcardno": "0000001623187097",
       			"thingvin": "LFCAH96W2N3003518",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.77553,
       			"maplng": 111.697162,
       			"mapaddr": null,
       			"staffname": "易育强",
       			"staffmobile": "18627610847",
       			"taskid": "0",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.691666",
       			"vehiclelat": "27.778898",
       			"vehicleheight": "174",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "166983.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225218",
       			"todaymileage": "415.9",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "448",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307035",
       			"username": "187****7768",
       			"licenseplatenumber": "湘K19656D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W9N3003581",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/41118b240e07769b6d899eb5a38da4be.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/45370dc966327fea914d6fab234e9c90.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209628",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/da354ed0cf5901a08c5803c14c37954e.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/16d556fac5f7ef4cfaa31019700c599e.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KM958挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/aa2ec895271fdf5f60ca25d46f41c2fe.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724813544",
       			"dateline": "1684304391",
       			"modifytime": "1725702041",
       			"operateuid": "307035",
       			"operateuname": "187****",
       			"thingid": "448",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "",
       			"thingregcode": "湘K19656D",
       			"thingregnum": "19656",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "40818676303",
       			"outcardno": "0000003234660249",
       			"thingvin": "LFCAH96W9N3003581",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.092026,
       			"maplng": 112.969242,
       			"mapaddr": null,
       			"staffname": "汤专和",
       			"staffmobile": "18785497768",
       			"taskid": "22124",
       			"tasknum": "226",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "112.963736",
       			"vehiclelat": "28.095473",
       			"vehicleheight": "61",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "159316.9",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225442",
       			"todaymileage": "390.7",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "360",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307591",
       			"username": "136****0299",
       			"licenseplatenumber": "湘K06276D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96WXN3003721",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/6d4e31f1b0b9bf03d7da24fa41c02471.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/47b3d9495fa7dd0c5eb217b5e8512ccb.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209648",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/f20dbe3137b5240733f276f00f292579.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/d2acbd1609906f7c23bf5dfbd3fcbda0.jpg",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KT582挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/52be59b16a5b5ec4e328098e66900be9.jpg",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725709456",
       			"operateuid": "307591",
       			"operateuname": "180****8540",
       			"thingid": "360",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D11",
       			"thingregcode": "湘K06276D",
       			"thingregnum": "06276",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848677482",
       			"outcardno": "0000002692017049",
       			"thingvin": "LFCAH96WXN3003721",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049159,
       			"maplng": 112.970593,
       			"mapaddr": null,
       			"staffname": "杜孝中",
       			"staffmobile": "18075878540",
       			"taskid": "0",
       			"tasknum": "221",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "112.965086",
       			"vehiclelat": "28.052598",
       			"vehicleheight": "37",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "173306.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224709",
       			"todaymileage": "341.3",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "552",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "293644",
       			"username": "????good luck????????",
       			"licenseplatenumber": "湘K09288D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W6N3002789",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b2e05db30374b10e9d2e3ceb9cac45bd.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209672",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/7bbed2d3dbcce5609ac483721401a916.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KM869挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/00014dcdc0546f2e1f3c4b2331a1feb2.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725718037",
       			"operateuid": "293644",
       			"operateuname": "????good luck????????",
       			"thingid": "366",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D28",
       			"thingregcode": "湘K09288D",
       			"thingregnum": "09288",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846257043",
       			"outcardno": "0000002160649113",
       			"thingvin": "LFCAH96W6N3002789",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048497,
       			"maplng": 112.970783,
       			"mapaddr": null,
       			"staffname": "????good luck????????",
       			"staffmobile": "19908451579",
       			"taskid": "0",
       			"tasknum": "228",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965276",
       			"vehiclelat": "28.051935",
       			"vehicleheight": "59",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "152263.4",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225454",
       			"todaymileage": "399.2",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "340",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "305692",
       			"username": "15616088937",
       			"licenseplatenumber": "湘K01738D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96WXN3003492",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/c9aec75b92472f429ab8c6af62c248b3.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "2023-12-29",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209664",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2023/05/khy/57933e31-3c3e-40e3-9227-89c4114a8ec7.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2024-06-04",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "11700",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KR276挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/72bbf89e39709735752abd5cc8e6da66.jpg",
       			"truckaxles": "6轴",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724812445",
       			"dateline": "1678693585",
       			"modifytime": "1725700113",
       			"operateuid": "305692",
       			"operateuname": "覃委",
       			"thingid": "340",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D29",
       			"thingregcode": "湘K01738D",
       			"thingregnum": "01738",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64848679897",
       			"outcardno": "0000002694871193",
       			"thingvin": "LFCAH96WXN3003492",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.049097,
       			"maplng": 112.970582,
       			"mapaddr": null,
       			"staffname": "覃委",
       			"staffmobile": "15616088937",
       			"taskid": "0",
       			"tasknum": "208",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965075",
       			"vehiclelat": "28.052536",
       			"vehicleheight": "37",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "169506.5",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224558",
       			"todaymileage": "310.0",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "355",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307259",
       			"username": "刘勇志",
       			"licenseplatenumber": "湘K05538D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W5N3002833",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/46c672deffbb09088950c0e246b2126a.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-30",
       			"licenseregisterdate": "2022-12-30",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209633",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/6ed80193d225823606c38a247312ee8a.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-30",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KN181挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725705538",
       			"operateuid": "307259",
       			"operateuname": "15343085309",
       			"thingid": "355",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D35",
       			"thingregcode": "湘K05538D",
       			"thingregnum": "05538",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846241059",
       			"outcardno": "0000002147864473",
       			"thingvin": "LFCAH96W5N3002833",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775422,
       			"maplng": 111.697106,
       			"mapaddr": null,
       			"staffname": "刘勇志",
       			"staffmobile": "15343085309",
       			"taskid": "0",
       			"tasknum": "229",
       			"leavestatus": "0",
       			"thingstatus": "20",
       			"applystatus": "0",
       			"operatemsg": "已到达完成卸货",
       			"vehiclelng": "111.691610",
       			"vehiclelat": "27.778790",
       			"vehicleheight": "176",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "151575.1",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225455",
       			"todaymileage": "481.6",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "350",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300275",
       			"username": "潘朕",
       			"licenseplatenumber": "湘K02776D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W2N3003549",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/569822d1e0414a63f905ff036746f368.png",
       			"licensesideimage": "",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-21",
       			"licenseregisterdate": "2022-12-21",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209637",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/1ca772f80b477a1389c10866e9b6e21a.jpg",
       			"transportlicenseside": "",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-21",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KK658挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "None",
       			"truckaxles": "None",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725711396",
       			"operateuid": "300275",
       			"operateuname": "139****6798",
       			"thingid": "350",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D52",
       			"thingregcode": "湘K02776D",
       			"thingregnum": "02776",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846210564",
       			"outcardno": "0000002417561498",
       			"thingvin": "LFCAH96W2N3003549",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775608,
       			"maplng": 111.694992,
       			"mapaddr": null,
       			"staffname": "潘朕",
       			"staffmobile": "13973676798",
       			"taskid": "0",
       			"tasknum": "234",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "111.689500",
       			"vehiclelat": "27.778980",
       			"vehicleheight": "147",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "161875.7",
       			"vehiclewarn": "524288",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225441",
       			"todaymileage": "423.1",
       			"vehicleonline": "1"
       		},
       		{
       			"truckid": "524",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "300566",
       			"username": "173****6933",
       			"licenseplatenumber": "湘K05676D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W0N3003579",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/b8b57223b5eadb7257266556b855e6ba.png",
       			"licensesideimage": "tgjffwl/image/2024/08/khy/a710511a82a8b29d57b7fd2b2dad3e1f.jpg",
       			"licenseexpiredate": "1970-01-01",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209676",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/439f2fb1836346f3464d8de83561eef7.jpg",
       			"transportlicenseside": "tgjffwl/image/2024/08/khy/31712a233bfbfa143c6a86641137efda.jpg",
       			"transportvalidenddate": "2026-03-28",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "0",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KT705挂",
       			"trailertypecode": "",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/106b794b2abd9965c6db0166dee3caf1.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725627602",
       			"operateuid": "300566",
       			"operateuname": "173****6933",
       			"thingid": "356",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D55",
       			"thingregcode": "湘K05676D",
       			"thingregnum": "05676",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846237284",
       			"outcardno": "0000001619496601",
       			"thingvin": "LFCAH96W0N3003579",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 27.775897,
       			"maplng": 111.697243,
       			"mapaddr": null,
       			"staffname": "173****6933",
       			"staffmobile": "17397236933",
       			"taskid": "0",
       			"tasknum": "233",
       			"leavestatus": "0",
       			"thingstatus": "18",
       			"applystatus": "0",
       			"operatemsg": "已装货发车",
       			"vehiclelng": "111.691746",
       			"vehiclelat": "27.779265",
       			"vehicleheight": "187",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "28038.3",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907224854",
       			"todaymileage": "304.5",
       			"vehicleonline": "0"
       		},
       		{
       			"truckid": "551",
       			"businessid": "tgjffwl",
       			"corpid": "25",
       			"corpname": "货满满",
       			"userid": "307152",
       			"username": "189****1198",
       			"licenseplatenumber": "湘K11989D",
       			"truckowner": "涟源瑞麟智慧物流有限公司",
       			"identifycode": "LFCAH96W7N3003580",
       			"licensemainimage": "tgjffwl/image/2024/08/khy/6cab437c6a5f8700cbe07fbdba98d0c3.png",
       			"licensesideimage": "undefined",
       			"licenseexpiredate": "2035-08-26",
       			"licenseissuedate": "2022-12-22",
       			"licenseregisterdate": "2022-12-22",
       			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
       			"roadtransportnumber": "431382209647",
       			"roadtransportpermitno": "431382204891",
       			"transportlicensemain": "tgjffwl/image/2024/08/khy/404daa711c052ba918725ffa1c62905b.jpg",
       			"transportlicenseside": "undefined",
       			"transportvalidenddate": "2026-03-27",
       			"trucktypecode": "Q11",
       			"platecolor": "5",
       			"energytype": "C",
       			"registerdate": "2022-12-22",
       			"inspectionenddate": "2024-12-31",
       			"usenature": "货运",
       			"loadweight": "37170",
       			"loadlength": "0.00",
       			"totalweight": "48870",
       			"curbweight": "10400",
       			"outlinelength": "7345",
       			"outlinewidth": "2545",
       			"outlineheight": "3715",
       			"trailerplatenumber": "湘KA880挂",
       			"trailertypecode": "B16",
       			"trailerloadweight": "0",
       			"businessholdsname": "涟源瑞麟智慧物流有限公司",
       			"carwithownerimage": "tgjffwl/image/2024/08/khy/cccaadfe7c03563f259bee874e0b3d5d.jpg",
       			"truckaxles": "",
       			"truckstatus": "1",
       			"syncstatus": "1",
       			"auditstatus": "2",
       			"auditmsg": null,
       			"audittime": "1724747635",
       			"dateline": "1678693585",
       			"modifytime": "1725702843",
       			"operateuid": "307152",
       			"operateuname": "189****1198",
       			"thingid": "372",
       			"thingname": "三一",
       			"thingtype": "1",
       			"thingbrand": null,
       			"thingteamid": "3",
       			"thingteam": "萧建春",
       			"placeid": "0",
       			"placename": "",
       			"thingbelongto": "涟源瑞麟智慧物流有限公司",
       			"thingboxtype": "",
       			"thingseqcode": "D61",
       			"thingregcode": "湘K11989D",
       			"thingregnum": "11989",
       			"thingpower": "2",
       			"thingcat": "重型半挂牵引车",
       			"vehiclecode": "64846239423",
       			"outcardno": "0000002425426074",
       			"thingvin": "LFCAH96W7N3003580",
       			"trailercode": null,
       			"thington": "37.170",
       			"thingimage": null,
       			"thingregdate": "",
       			"maplat": 28.048515,
       			"maplng": 112.970833,
       			"mapaddr": null,
       			"staffname": "189****1198",
       			"staffmobile": "18974981198",
       			"taskid": "0",
       			"tasknum": "230",
       			"leavestatus": "0",
       			"thingstatus": "5",
       			"applystatus": "0",
       			"operatemsg": "货运司机已完工",
       			"vehiclelng": "112.965325",
       			"vehiclelat": "28.051953",
       			"vehicleheight": "41",
       			"vehiclespeed": "0.00",
       			"vehicledirection": "0",
       			"vehiclemileage": "147593.2",
       			"vehiclewarn": "0",
       			"vehicleduration": "0.0",
       			"vehicledate": "20240907225435",
       			"todaymileage": "345.3",
       			"vehicleonline": "1"
       		}
       	]
       
    }else if(obj=='total'){
        data={
        		"today": {
        			"taskcnt": "1",
        			"thingcnt": "1",
        			"plancnt": "1",
        			"doingcnt": "0",
        			"finishcnt": "1",
        			"startweightsum": "34.11",
        			"finishweightsum": "33.77",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "0.00"
        		},
        		"month": {
        			"taskcnt": "17",
        			"thingcnt": "1",
        			"plancnt": "17",
        			"doingcnt": "0",
        			"finishcnt": "17",
        			"startweightsum": "574.31",
        			"finishweightsum": "572.55",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "2633.20"
        		},
        		"year": {
        			"taskcnt": "416",
        			"thingcnt": "1",
        			"plancnt": "416",
        			"doingcnt": "0",
        			"finishcnt": "416",
        			"startweightsum": "13927.44",
        			"finishweightsum": "13862.12",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "161480.62"
        		},
        		"total": {
        			"taskcnt": "878",
        			"thingcnt": "1",
        			"plancnt": "878",
        			"doingcnt": "0",
        			"finishcnt": "878",
        			"startweightsum": "29306.10",
        			"finishweightsum": "29100.48",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "255369.32"
        		}
        	}
        
    }else if(obj=='day7'){
        data= {
        		"day7": [
        			{
        				"taskdate": "2024-09-01",
        				"taskcnt": "2",
        				"thingcnt": "1",
        				"plancnt": "2",
        				"doingcnt": "0",
        				"finishcnt": "2",
        				"startweightsum": "66.37",
        				"finishweightsum": "66.45",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "475.68"
        			},
        			{
        				"taskdate": "2024-09-02",
        				"taskcnt": "3",
        				"thingcnt": "1",
        				"plancnt": "3",
        				"doingcnt": "0",
        				"finishcnt": "3",
        				"startweightsum": "99.01",
        				"finishweightsum": "99.13",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "411.56"
        			},
        			{
        				"taskdate": "2024-09-03",
        				"taskcnt": "4",
        				"thingcnt": "1",
        				"plancnt": "4",
        				"doingcnt": "0",
        				"finishcnt": "4",
        				"startweightsum": "138.97",
        				"finishweightsum": "138.10",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "354.02"
        			},
        			{
        				"taskdate": "2024-09-04",
        				"taskcnt": "3",
        				"thingcnt": "1",
        				"plancnt": "3",
        				"doingcnt": "0",
        				"finishcnt": "3",
        				"startweightsum": "101.35",
        				"finishweightsum": "100.92",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "433.24"
        			},
        			{
        				"taskdate": "2024-09-05",
        				"taskcnt": "2",
        				"thingcnt": "1",
        				"plancnt": "2",
        				"doingcnt": "0",
        				"finishcnt": "2",
        				"startweightsum": "69.24",
        				"finishweightsum": "68.76",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "553.10"
        			},
        			{
        				"taskdate": "2024-09-06",
        				"taskcnt": "2",
        				"thingcnt": "1",
        				"plancnt": "2",
        				"doingcnt": "0",
        				"finishcnt": "2",
        				"startweightsum": "65.26",
        				"finishweightsum": "65.42",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "405.60"
        			},
        			{
        				"taskdate": "2024-09-07",
        				"taskcnt": "1",
        				"thingcnt": "1",
        				"plancnt": "1",
        				"doingcnt": "0",
        				"finishcnt": "1",
        				"startweightsum": "34.11",
        				"finishweightsum": "33.77",
        				"feerepair": "0.00",
        				"feeother": "0.00",
        				"feesalary": "0.00",
        				"billmoney": "0.00"
        			}
        		]
        	}
        
    }else if(obj=='user'){
       
        list= [
        		{
        			"billid": "104923",
        			"corpid": "25",
        			"taskid": "22097",
        			"detailid": "62737",
        			"thingid": "344",
        			"taskdate": "2024-09-07",
        			"billno": "24090720974923",
        			"userid": "299368",
        			"username": "周雄",
        			"staffname": "周雄",
        			"thingregcode": "湘K00608D",
        			"trailercode": null,
        			"configid": "0",
        			"taskprice": "0.00",
        			"startbillno": "",
        			"startplacename": "齐兴",
        			"startbillaccount": "",
        			"startweightreal": "34.11",
        			"startimagelist": [
        				"tgjffwl/image/2024/09/khy/349464dc3ee53bdb445f4db1300367e4.jpg"
        			],
        			"finishbillno": "",
        			"finishplacename": "长沙华力",
        			"finishbillaccount": "",
        			"finishweightreal": "33.77",
        			"finishimagelist": [
        				"tgjffwl/image/2024/09/khy/349464dc3ee53bdb445f4db1300367e4.jpg"
        			],
        			"weightdiffer": "0.34",
        			"taskgoodsname": "13籽",
        			"taskstartdate": "2024-09-07 08:29:26",
        			"taskfinishdate": "2024-09-07 10:58:57",
        			"taskhour": "0.00",
        			"taskstatus": "20",
        			"billuserids": null,
        			"billwarntime": "0",
        			"billwarncnt": "0",
        			"billmoney": "0.00",
        			"paidmoney": "500.00",
        			"feeadvance": "0.00",
        			"feetoll": "0.00",
        			"feepower": "0.00",
        			"feerepair": "0.00",
        			"feeload": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"feetotal": "0.00",
        			"feememo": "",
        			"moneyprev": "0.00",
        			"moneylast": "0.00",
        			"checkstatus": "0",
        			"checkmessage": "",
        			"confirmid": "0",
        			"confirmstatus": "0",
        			"auditstatus": "5",
        			"auditmessage": "",
        			"packstatus": "2",
        			"cashoutid": "0",
        			"syncstatus": "2",
        			"syncbillno": "235865850622031121",
        			"syncmessage": null,
        			"imagelist": [],
        			"riskstatus": "6",
        			"risktext": "要素缺失",
        			"riskerror": "1、运单装卸货点经纬度未在运单装卸货区划围栏内或司机未操作;2、司机未进行卸货和装货操作;",
        			"synctime": "1725722821",
        			"dateline": "1725691226",
        			"modifytime": "1725701009",
        			"operateuid": "274028",
        			"operateuname": "19911534004",
        			"taskno": "2402209701",
        			"tasktype": "1",
        			"taskfromid": "12",
        			"taskfromname": "齐兴",
        			"tasktoid": "85",
        			"tasktoname": "长沙华力",
        			"content": null,
        			"taskgoodsweight": "0.00",
        			"groupstatus": "20",
        			"thingteam": "萧建春",
        			"staffmobile": "18073862772",
        			"useravatar": "1721645949",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/04/26/299368_16825148851743.jpg?x-oss-process=style/common",
        			"usermobile": "18022315423",
        			"useravatar_small": "avatar/user/000/29/93/68_small.jpg?t=1721645949",
        			"useravatar_middle": "avatar/user/000/29/93/68_middle.jpg?t=1721645949"
        		}
        	]
        
    }else if(obj=='thing'){
        data= {
        		"truckid": "344",
        		"businessid": "tgjffwl",
        		"corpid": "25",
        		"corpname": "货满满",
        		"userid": "299368",
        		"username": "周雄",
        		"licenseplatenumber": "湘K00608D",
        		"truckowner": "涟源瑞麟智慧物流有限公司",
        		"identifycode": "LFCAH96W0N3003582",
        		"licensemainimage": "tgjffwl/image/2024/08/khy/e82d4035052a847b7c27275c3a87e8f5.png",
        		"licensesideimage": "",
        		"licenseexpiredate": "1970-01-01",
        		"licenseissuedate": "2022-12-21",
        		"licenseregisterdate": "2022-12-21",
        		"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        		"roadtransportnumber": "431382209718",
        		"roadtransportpermitno": "431382204891",
        		"transportlicensemain": "tgjffwl/image/2024/08/khy/9d1a19f0267b31846a1f310fcf98c23a.jpg",
        		"transportlicenseside": "",
        		"transportvalidenddate": "2026-04-02",
        		"trucktypecode": "Q11",
        		"platecolor": "5",
        		"energytype": "C",
        		"registerdate": "2022-12-21",
        		"inspectionenddate": "2024-12-31",
        		"usenature": "货运",
        		"loadweight": "37170",
        		"loadlength": "0.00",
        		"totalweight": "48870",
        		"curbweight": "11700",
        		"outlinelength": "7345",
        		"outlinewidth": "2545",
        		"outlineheight": "3715",
        		"trailerplatenumber": "湘KD826挂",
        		"trailertypecode": "B16",
        		"trailerloadweight": "0",
        		"businessholdsname": "涟源瑞麟智慧物流有限公司",
        		"carwithownerimage": "tgjffwl/image/2024/08/khy/48ea7e06c4fb3543f10e292a72df8096.jpg",
        		"truckaxles": "None",
        		"truckstatus": "1",
        		"syncstatus": "1",
        		"auditstatus": "2",
        		"auditmsg": null,
        		"audittime": "1724747656",
        		"dateline": "1678693585",
        		"modifytime": "1725691263",
        		"operateuid": "299368",
        		"operateuname": "180****2772",
        		"thingid": "344",
        		"thingname": "三一",
        		"thingtype": "1",
        		"thingbrand": null,
        		"thingteamid": "3",
        		"thingteam": "萧建春",
        		"placeid": "0",
        		"placename": "",
        		"thingbelongto": "涟源瑞麟智慧物流有限公司",
        		"thingboxtype": "",
        		"thingseqcode": "",
        		"thingregcode": "湘K00608D",
        		"thingregnum": "00608",
        		"thingpower": "2",
        		"thingcat": "重型半挂牵引车",
        		"vehiclecode": "64846210336",
        		"outcardno": "0000002152393625",
        		"thingvin": "LFCAH96W0N3003582",
        		"trailercode": null,
        		"thington": "37.170",
        		"thingimage": null,
        		"thingregdate": "",
        		"maplat": null,
        		"maplng": null,
        		"mapaddr": null,
        		"staffname": "周雄",
        		"staffmobile": "18073862772",
        		"taskid": "0",
        		"tasknum": "228",
        		"leavestatus": "0",
        		"thingstatus": "5",
        		"applystatus": "0",
        		"operatemsg": "货运司机已完工",
        		"linkman": "",
        		"linktel": "",
        		"vehiclelng": "111.691595",
        		"vehiclelat": "27.779056",
        		"vehicleheight": "159",
        		"vehiclespeed": "0.00",
        		"vehicledirection": "0",
        		"vehiclemileage": "182142.8",
        		"vehiclewarn": "0",
        		"vehicleduration": "0.0",
        		"vehicledate": "20240907232909",
        		"vehicleonline": "1",
        		"useravatar": "1721645949",
        		"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/04/26/299368_16825148851743.jpg?x-oss-process=style/common",
        		"usermobile": "18073862772",
        		"useravatar_small": "avatar/user/000/29/93/68_small.jpg?t=1721645949",
        		"useravatar_middle": "avatar/user/000/29/93/68_middle.jpg?t=1721645949",
        		"stafflist": [
        			{
        				"staffid": "611",
        				"userid": "299368",
        				"username": "18073862772",
        				"staffname": "周雄",
        				"staffmobile": "18073862772",
        				"thingid": "344"
        			}
        		]
        	}
        
    }else if(obj=='userlist'){
        
        list= [
        		{
        			"totaltask": "11",
        			"totalstartweight": "329.12",
        			"totalfinishweight": "323.77",
        			"totalbillmoney": "1201.51",
        			"groupid": "307591",
        			"userid": "307591",
        			"username": "杜孝中",
        			"thingid": "360",
        			"usermobile": "18075878540",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "6",
        			"totalstartweight": "201.82",
        			"totalfinishweight": "201.82",
        			"totalbillmoney": "0.00",
        			"groupid": "293132",
        			"userid": "293132",
        			"username": "肖彪",
        			"thingid": "175",
        			"usermobile": "15347382878",
        			"useravatar": "1665279034",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIjp0YCZia5ekuoXZGG1qv5QAUpG3rTClOcpTib6QRz4TgCCkJRbUyUwW6iaibsfhrGAg8lwwnmqmvYiaw/132",
        			"useravatar_small": "avatar/user/000/29/31/32_small.jpg?t=1665279034",
        			"useravatar_middle": "avatar/user/000/29/31/32_middle.jpg?t=1665279034"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "134.07",
        			"totalfinishweight": "134.09",
        			"totalbillmoney": "203.11",
        			"groupid": "300985",
        			"userid": "300985",
        			"username": "谭勇",
        			"thingid": "376",
        			"usermobile": "15773888621",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "123.16",
        			"totalfinishweight": "120.83",
        			"totalbillmoney": "240.00",
        			"groupid": "300277",
        			"userid": "300277",
        			"username": "王建民",
        			"thingid": "389",
        			"usermobile": "18974127912",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "122.18",
        			"totalfinishweight": "120.46",
        			"totalbillmoney": "240.00",
        			"groupid": "307086",
        			"userid": "307086",
        			"username": "黄华",
        			"thingid": "842",
        			"usermobile": "18073286958",
        			"useravatar": "1721966887",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/07/26/307086_17219668865920.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/70/86_small.jpg?t=1721966887",
        			"useravatar_middle": "avatar/user/000/30/70/86_middle.jpg?t=1721966887"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "120.81",
        			"totalfinishweight": "119.53",
        			"totalbillmoney": "499.36",
        			"groupid": "300276",
        			"userid": "300276",
        			"username": "张新铭",
        			"thingid": "347",
        			"usermobile": "18033081916",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "121.68",
        			"totalfinishweight": "119.38",
        			"totalbillmoney": "240.00",
        			"groupid": "305698",
        			"userid": "305698",
        			"username": "李浩",
        			"thingid": "369",
        			"usermobile": "18673128160",
        			"useravatar": "1721633442",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/07/22/305698_17216334406343.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/56/98_small.jpg?t=1721633442",
        			"useravatar_middle": "avatar/user/000/30/56/98_middle.jpg?t=1721633442"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "119.69",
        			"totalfinishweight": "118.31",
        			"totalbillmoney": "240.00",
        			"groupid": "301771",
        			"userid": "301771",
        			"username": "刘成",
        			"thingid": "361",
        			"usermobile": "18373392006",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "119.63",
        			"totalfinishweight": "117.97",
        			"totalbillmoney": "240.00",
        			"groupid": "307353",
        			"userid": "307353",
        			"username": "罗兰田",
        			"thingid": "379",
        			"usermobile": "19918805088",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "90.16",
        			"totalfinishweight": "117.93",
        			"totalbillmoney": "240.00",
        			"groupid": "301391",
        			"userid": "301391",
        			"username": "吴孟均",
        			"thingid": "346",
        			"usermobile": "17573885598",
        			"useravatar": "1724650903",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/04/01/303713_17119352266832.jpeg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/13/91_small.jpg?t=1724650903",
        			"useravatar_middle": "avatar/user/000/30/13/91_middle.jpg?t=1724650903"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "119.23",
        			"totalfinishweight": "117.64",
        			"totalbillmoney": "240.00",
        			"groupid": "305732",
        			"userid": "305732",
        			"username": "熊望",
        			"thingid": "388",
        			"usermobile": "18973146712",
        			"useravatar": "1721562098",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/07/21/305732_17215620977427.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/57/32_small.jpg?t=1721562098",
        			"useravatar_middle": "avatar/user/000/30/57/32_middle.jpg?t=1721562098"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "119.19",
        			"totalfinishweight": "117.59",
        			"totalbillmoney": "240.00",
        			"groupid": "305731",
        			"userid": "305731",
        			"username": "张泽榕",
        			"thingid": "386",
        			"usermobile": "17775157116",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "118.97",
        			"totalfinishweight": "117.38",
        			"totalbillmoney": "240.00",
        			"groupid": "300736",
        			"userid": "300736",
        			"username": "王立军",
        			"thingid": "341",
        			"usermobile": "13875856311",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "4",
        			"totalstartweight": "117.75",
        			"totalfinishweight": "115.88",
        			"totalbillmoney": "240.00",
        			"groupid": "301706",
        			"userid": "301706",
        			"username": "龙韶峰",
        			"thingid": "937",
        			"usermobile": "16673891599",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "3",
        			"totalstartweight": "76.16",
        			"totalfinishweight": "105.55",
        			"totalbillmoney": "312.93",
        			"groupid": "299397",
        			"userid": "299397",
        			"username": "廖建红",
        			"thingid": "794",
        			"usermobile": "13278869115",
        			"useravatar": "1685234828",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/05/28/299397_16852348271425.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/29/93/97_small.jpg?t=1685234828",
        			"useravatar_middle": "avatar/user/000/29/93/97_middle.jpg?t=1685234828"
        		},
        		{
        			"totaltask": "3",
        			"totalstartweight": "106.23",
        			"totalfinishweight": "105.48",
        			"totalbillmoney": "0.00",
        			"groupid": "307309",
        			"userid": "307309",
        			"username": "文鹏程",
        			"thingid": "771",
        			"usermobile": "18373780789",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        	]
        
    }else if(obj=='userlists'){
        list= [
        		{
        			"totaltask": "1258",
        			"totalstartweight": "39610.95",
        			"totalfinishweight": "39052.65",
        			"totalbillmoney": "221312.22",
        			"groupid": "293151",
        			"userid": "293151",
        			"username": "黄信",
        			"thingid": "391",
        			"usermobile": "15898446788",
        			"useravatar": "1686541048",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/6ay6OtX1r4lRcLfJUibkhFpUkzgsAOyD5T3miaYZ1MdGMWE7iaXstovFQykaiboJ0S5ibnNCc2rIzU1c7eP5IfiaMtwA/132",
        			"useravatar_small": "avatar/user/000/29/31/51_small.jpg?t=1686541048",
        			"useravatar_middle": "avatar/user/000/29/31/51_middle.jpg?t=1686541048"
        		},
        		{
        			"totaltask": "1118",
        			"totalstartweight": "35159.20",
        			"totalfinishweight": "34613.86",
        			"totalbillmoney": "251465.59",
        			"groupid": "299392",
        			"userid": "299392",
        			"username": "张亚军",
        			"thingid": "381",
        			"usermobile": "13347238997",
        			"useravatar": "1692354535",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/04/14/299392_16814486466055.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/29/93/92_small.jpg?t=1692354535",
        			"useravatar_middle": "avatar/user/000/29/93/92_middle.jpg?t=1692354535"
        		},
        		{
        			"totaltask": "878",
        			"totalstartweight": "29306.10",
        			"totalfinishweight": "29100.48",
        			"totalbillmoney": "255369.32",
        			"groupid": "299368",
        			"userid": "299368",
        			"username": "周雄",
        			"thingid": "344",
        			"usermobile": "18073862772",
        			"useravatar": "1721645949",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/04/26/299368_16825148851743.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/29/93/68_small.jpg?t=1721645949",
        			"useravatar_middle": "avatar/user/000/29/93/68_middle.jpg?t=1721645949"
        		},
        		{
        			"totaltask": "717",
        			"totalstartweight": "24213.46",
        			"totalfinishweight": "23999.80",
        			"totalbillmoney": "285830.99",
        			"groupid": "300691",
        			"userid": "300691",
        			"username": "蒋国平",
        			"thingid": "458",
        			"usermobile": "13347330395",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "601",
        			"totalstartweight": "20036.99",
        			"totalfinishweight": "19881.38",
        			"totalbillmoney": "179736.63",
        			"groupid": "299369",
        			"userid": "299369",
        			"username": "廖立加",
        			"thingid": "378",
        			"usermobile": "18973815569",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "580",
        			"totalstartweight": "19476.18",
        			"totalfinishweight": "19375.20",
        			"totalbillmoney": "170099.34",
        			"groupid": "300171",
        			"userid": "300171",
        			"username": "周裔庄",
        			"thingid": "385",
        			"usermobile": "18373856080",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "569",
        			"totalstartweight": "18957.94",
        			"totalfinishweight": "18970.06",
        			"totalbillmoney": "159796.51",
        			"groupid": "299629",
        			"userid": "299629",
        			"username": "刘军",
        			"thingid": "387",
        			"usermobile": "18973898766",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "582",
        			"totalstartweight": "17979.22",
        			"totalfinishweight": "17714.32",
        			"totalbillmoney": "61324.55",
        			"groupid": "300565",
        			"userid": "300565",
        			"username": "田仁锋",
        			"thingid": "0",
        			"usermobile": "13974396116",
        			"useravatar": "1686554732",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/jicBxVAD7ib6dxOxZiaCNX8yAkrUW4mgeX2EWDWpdGToCdugzbxp9XO1v0lFcm1Esmuq4gDPicRJNUsR3BdZAlkGdQ/132",
        			"useravatar_small": "avatar/user/000/30/05/65_small.jpg?t=1686554732",
        			"useravatar_middle": "avatar/user/000/30/05/65_middle.jpg?t=1686554732"
        		},
        		{
        			"totaltask": "511",
        			"totalstartweight": "16947.00",
        			"totalfinishweight": "16902.81",
        			"totalbillmoney": "21598.44",
        			"groupid": "293132",
        			"userid": "293132",
        			"username": "肖彪",
        			"thingid": "175",
        			"usermobile": "15347382878",
        			"useravatar": "1665279034",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIjp0YCZia5ekuoXZGG1qv5QAUpG3rTClOcpTib6QRz4TgCCkJRbUyUwW6iaibsfhrGAg8lwwnmqmvYiaw/132",
        			"useravatar_small": "avatar/user/000/29/31/32_small.jpg?t=1665279034",
        			"useravatar_middle": "avatar/user/000/29/31/32_middle.jpg?t=1665279034"
        		},
        		{
        			"totaltask": "513",
        			"totalstartweight": "16192.72",
        			"totalfinishweight": "15988.49",
        			"totalbillmoney": "96866.08",
        			"groupid": "299719",
        			"userid": "299719",
        			"username": "李开颜",
        			"thingid": "349",
        			"usermobile": "18932433459",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "472",
        			"totalstartweight": "15835.37",
        			"totalfinishweight": "15640.71",
        			"totalbillmoney": "107529.61",
        			"groupid": "299630",
        			"userid": "299630",
        			"username": "李均明",
        			"thingid": "342",
        			"usermobile": "15273862177",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "487",
        			"totalstartweight": "15135.82",
        			"totalfinishweight": "14913.95",
        			"totalbillmoney": "62114.91",
        			"groupid": "301228",
        			"userid": "301228",
        			"username": "刘铁成",
        			"thingid": "384",
        			"usermobile": "13135330050",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "493",
        			"totalstartweight": "15003.36",
        			"totalfinishweight": "14857.12",
        			"totalbillmoney": "3765.05",
        			"groupid": "299623",
        			"userid": "299623",
        			"username": "孙财云",
        			"thingid": "0",
        			"usermobile": "15386395818",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "477",
        			"totalstartweight": "14755.50",
        			"totalfinishweight": "14516.99",
        			"totalbillmoney": "24050.47",
        			"groupid": "299928",
        			"userid": "299928",
        			"username": "吴宇",
        			"thingid": "0",
        			"usermobile": "15907302531",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "464",
        			"totalstartweight": "14200.40",
        			"totalfinishweight": "14064.50",
        			"totalbillmoney": "13705.12",
        			"groupid": "300276",
        			"userid": "300276",
        			"username": "张新铭",
        			"thingid": "347",
        			"usermobile": "18033081916",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "460",
        			"totalstartweight": "14155.12",
        			"totalfinishweight": "13958.56",
        			"totalbillmoney": "33069.68",
        			"groupid": "300279",
        			"userid": "300279",
        			"username": "杨波",
        			"thingid": "373",
        			"usermobile": "13958802469",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "381",
        			"totalstartweight": "11199.27",
        			"totalfinishweight": "11599.84",
        			"totalbillmoney": "11432.59",
        			"groupid": "299374",
        			"userid": "299374",
        			"username": "曾凡云",
        			"thingid": "0",
        			"usermobile": "13687390299",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "358",
        			"totalstartweight": "11074.00",
        			"totalfinishweight": "10893.01",
        			"totalbillmoney": "12236.49",
        			"groupid": "300277",
        			"userid": "300277",
        			"username": "王建民",
        			"thingid": "389",
        			"usermobile": "18974127912",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "291",
        			"totalstartweight": "10281.94",
        			"totalfinishweight": "10280.62",
        			"totalbillmoney": "316109.11",
        			"groupid": "295637",
        			"userid": "295637",
        			"username": "刘吉明",
        			"thingid": "540",
        			"usermobile": "13874130033",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "341",
        			"totalstartweight": "10467.18",
        			"totalfinishweight": "10239.75",
        			"totalbillmoney": "13583.93",
        			"groupid": "300736",
        			"userid": "300736",
        			"username": "王立军",
        			"thingid": "341",
        			"usermobile": "13875856311",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "308",
        			"totalstartweight": "10214.58",
        			"totalfinishweight": "10143.31",
        			"totalbillmoney": "26591.51",
        			"groupid": "299370",
        			"userid": "299370",
        			"username": "龚奇峰",
        			"thingid": "343",
        			"usermobile": "19873827222",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "289",
        			"totalstartweight": "9641.35",
        			"totalfinishweight": "9569.79",
        			"totalbillmoney": "22755.02",
        			"groupid": "300275",
        			"userid": "300275",
        			"username": "潘朕",
        			"thingid": "350",
        			"usermobile": "13973676798",
        			"useravatar": "1682905119",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/05/01/300275_16829051180286.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/02/75_small.jpg?t=1682905119",
        			"useravatar_middle": "avatar/user/000/30/02/75_middle.jpg?t=1682905119"
        		},
        		{
        			"totaltask": "279",
        			"totalstartweight": "9264.44",
        			"totalfinishweight": "9196.08",
        			"totalbillmoney": "14754.06",
        			"groupid": "299373",
        			"userid": "299373",
        			"username": "李鹏",
        			"thingid": "359",
        			"usermobile": "18152788209",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "293",
        			"totalstartweight": "8977.27",
        			"totalfinishweight": "8933.76",
        			"totalbillmoney": "3717.18",
        			"groupid": "293106",
        			"userid": "293106",
        			"username": "刘堤伟",
        			"thingid": "0",
        			"usermobile": "18175927255",
        			"useravatar": "1665279057",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/7QlJdpAG1V1ogZyrOZlzrve2iawNaZodFjOlCIbzBaFtyNYp0FcvWrYicSXAC0OI1xBbt7c5d5tbibAGELmiaSV5Hw/132",
        			"useravatar_small": "avatar/user/000/29/31/06_small.jpg?t=1665279057",
        			"useravatar_middle": "avatar/user/000/29/31/06_middle.jpg?t=1665279057"
        		},
        		{
        			"totaltask": "286",
        			"totalstartweight": "8662.19",
        			"totalfinishweight": "8558.62",
        			"totalbillmoney": "1848.06",
        			"groupid": "299718",
        			"userid": "299718",
        			"username": "龙昕辰",
        			"thingid": "0",
        			"usermobile": "15174342221",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "262",
        			"totalstartweight": "8592.93",
        			"totalfinishweight": "8534.83",
        			"totalbillmoney": "41043.91",
        			"groupid": "301706",
        			"userid": "301706",
        			"username": "龙韶峰",
        			"thingid": "937",
        			"usermobile": "16673891599",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "256",
        			"totalstartweight": "8580.42",
        			"totalfinishweight": "8506.49",
        			"totalbillmoney": "44254.62",
        			"groupid": "299716",
        			"userid": "299716",
        			"username": "李志勇",
        			"thingid": "0",
        			"usermobile": "19186525551",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "259",
        			"totalstartweight": "7978.65",
        			"totalfinishweight": "7898.88",
        			"totalbillmoney": "5999.45",
        			"groupid": "298504",
        			"userid": "298504",
        			"username": "蒋志强",
        			"thingid": "0",
        			"usermobile": "15115888096",
        			"useravatar": "1688732223",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2023/07/07/298504_16887321530757.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/29/85/04_small.jpg?t=1688732223",
        			"useravatar_middle": "avatar/user/000/29/85/04_middle.jpg?t=1688732223"
        		},
        		{
        			"totaltask": "231",
        			"totalstartweight": "7812.47",
        			"totalfinishweight": "7710.86",
        			"totalbillmoney": "46989.50",
        			"groupid": "300688",
        			"userid": "300688",
        			"username": "李六辉",
        			"thingid": "0",
        			"usermobile": "17752692990",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "224",
        			"totalstartweight": "7107.23",
        			"totalfinishweight": "6985.04",
        			"totalbillmoney": "43370.32",
        			"groupid": "302128",
        			"userid": "302128",
        			"username": "黄明豪",
        			"thingid": "547",
        			"usermobile": "18374503332",
        			"useravatar": "1724710918",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/08/27/302128_17247109175552.jpg?x-oss-process=style/common",
        			"useravatar_small": "avatar/user/000/30/21/28_small.jpg?t=1724710918",
        			"useravatar_middle": "avatar/user/000/30/21/28_middle.jpg?t=1724710918"
        		},
        		{
        			"totaltask": "209",
        			"totalstartweight": "6516.19",
        			"totalfinishweight": "6380.33",
        			"totalbillmoney": "2172.69",
        			"groupid": "300693",
        			"userid": "300693",
        			"username": "陈强",
        			"thingid": "0",
        			"usermobile": "18073321269",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        		{
        			"totaltask": "195",
        			"totalstartweight": "6144.81",
        			"totalfinishweight": "6098.51",
        			"totalbillmoney": "0.00",
        			"groupid": "299380",
        			"userid": "299380",
        			"username": "谭显武",
        			"thingid": "0",
        			"usermobile": "18390533299",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg"
        		},
        	]
        
    }else if(obj=='todayobj'){
        data={
            "today": {
            	"ordercnt": "1",
            	"thingcnt": "1",
            	"usercnt": "1",
            	"totalmoneysum": 233,
            	"totalpowersum": 420,
            	"chargewarn": null
            }
        }
        
    }else if(obj=='monthobj'){
        data={
            "month": {
            	"ordercnt": "11",
            	"thingcnt": "23",
            	"usercnt": "42",
            	"totalmoneysum": 2433,
            	"totalpowersum": 4332,
            	"chargewarn": null
            }
        }
        
    }
    
    if(type=='obj'){
        return data;
    }else{
        return list;
    }
         
}